<template>
    <div :class="['chat-wrap', agentConfig && agentConfig.style && agentConfig.style.style === 1 ? 'chat-newui' : '']" v-loading="showMask">
        <template v-if="agentConfig && agentConfig.style && agentConfig.style.style === 1">
            <div class="btn-close-pop">
                <i class="iconfont icon-guanbi" @click="closePop" />
            </div>
            <div class="ai-temp3">
                <img class="girl" :src="agentConfig && agentConfig.style && agentConfig.style.avatarId ? 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-' + agentConfig.style.avatarId + '.png' : $url + '/confiles/' + agentConfig.style.halfBodyImage" />
                <p>{{agentConfig && agentConfig.style ? agentConfig.style.text2 : ''}}</p>
            </div>
        </template>
        <!-- 历史记录按钮 -->
        <div class="history-btn" v-if="showHistoryBtn" @click="viewHistory">
            <i :class="['WSiconfont', isHistoryShown ? 'WSicon-browse-off' : 'WSicon-a-Frame427323515']"></i>
            {{ isHistoryShown ? '隐藏历史记录' : '查看历史记录' }}
        </div>

        <!-- 聊天主体区域 -->
        <div class="chat-main">
            <!-- AI头像和介绍 -->
            <div class="ai-intro" v-show="sessions.length === 0 && skin.avatar">
                <div class="title">
                    <img :src="agentConfig && agentConfig.style && agentConfig.style.style === 1 ? agentConfig.style.avatarId ? 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-' + agentConfig.style.avatarId + '.png' : $url + '/confiles/' + agentConfig.style.halfBodyImage : skin.avatar && skin.avatar.includes('bigdata') ? skin.avatar : $apiurl + skin.avatar" alt="AI头像">
                    <h5 :style="skin.sloganStyle">{{ agentConfig && agentConfig.style && agentConfig.style.style === 1 ? agentConfig.style.searchVal : skin.sloganText }}</h5>
                </div>
                <p :style="skin.descriptionStyle">{{ agentConfig && agentConfig.style && agentConfig.style.style === 1 ? agentConfig.style.text1 : skin.descriptionText }}</p>
            </div>
            <!-- 聊天记录区域 -->
            <div
                class="ctoArray-class"
                id="chat-msg"
                v-show="sessions.length !== 0"
                :style="{
                    'height': fileList.length > 0 ? 'calc(100% - 289px)' : 'calc(100% - 199px)',
                    'padding-top': showHistoryBtn ? '80px' : '10px'
                }"
            >
                <div class="scroll-btn" v-if="showScrollButtons">
                    <div class="btn-up" v-show="showUpButton" @click="scrollToPosition('up')">
                        <el-icon><ArrowUp /></el-icon>
                    </div>
                    <div class="btn-down" v-show="showDownButton" @click="scrollToPosition('down')">
                        <el-icon><ArrowDown /></el-icon>
                    </div>
                </div>
                <el-scrollbar class="el-menu-scrollbar__wrap" style="height:100%;" ref="scrollArea"
                    @scroll="handleScroll">
                    <div v-for="(its, index) in sessions" :key="index"
                        :class="['ai-list', its.role === 'user' ? 'ai-user' : 'ai-assistant']">
                        <div v-if="its.role === 'assistant'" class="ai-list-sys">
                            <img :src="agentConfig && agentConfig.style && agentConfig.style.style === 1 ? agentConfig.style.avatarId ? 'https://bigdata.topeti.com/PCRepository/mainPlatform/chat/s-' + agentConfig.style.avatarId + '.png' : $url + '/confiles/' + agentConfig.style.halfBodyImage : skin.avatar && skin.avatar.includes('bigdata') ? skin.avatar : $apiurl + skin.avatar">
                        </div>
                        <div class="ai-list-center">
                            <template v-if="its.role === 'user' && its.showQuestion !== false">
                                <div class="ai-list-text-wrapper" v-if="!its.edit">
                                    <div class="ai-list-text">
                                        <div v-html="formatContent(its.content)"></div>
                                        <div class="ai-edit">
                                            <!-- <el-tooltip style="display: none;" content="编辑" placement="top" effect="dark">
                                                <i class="WSiconfont WSicon-bianji" @click="editContent(its)" />
                                            </el-tooltip> -->
                                            <el-tooltip content="复制" placement="top" effect="dark">
                                                <i class="WSiconfont WSicon-fuzhiicon"
                                                    @click="copyToClipboard(its.content)" />
                                            </el-tooltip>
                                        </div>
                                    </div>                                    
                                </div>
                                <!-- 添加历史切换按钮 -->
                                <div class="history-switch" v-if="sessionsHistory.length > 0 && !its.edit">
                                    <el-icon @click="switchSession('prev')" 
                                    :class="{ disabled: currentSessionIndex === 0 }"><ArrowLeft /></el-icon>
                                    <span>{{ currentSessionIndex + 1 }}/{{ sessionsHistory.length }}</span>
                                    <el-icon @click="switchSession('next')" 
                                    :class="{ disabled: currentSessionIndex === sessionsHistory.length }"><ArrowRight /></el-icon>
                                </div>
                                <div class="ai-list-text-edit" v-if="its.edit">
                                    <textarea v-model="its.content" @keydown.enter.prevent="sendEdit(its)"></textarea>
                                    <div class="operate-btn">
                                        <span class="btn-cancel" @click="cancelEdit(its)">取消</span>
                                        <span class="btn-send" @click="sendEdit(its)">发送</span>
                                    </div>
                                </div>
                            </template>
                            <template v-else-if="its.role === 'assistant'">
                                <div class="ai-think" v-if="its.type !== 'image' && its.type !== 'video'" @click="toggleThinking"><i
                                    class="WSiconfont WSicon-icon_interests" />{{ isReasonModel ? (thinking ? '思考中' : '已思考(用时 ' + its.time + ' 秒)') : '已思考' }}<i class="iconfont icon-xiangshang" /></div>
                                                                <div class="app-check-list" v-if="its.appCheckResult && its.appCheckResult.length > 0">
                                <div class="app-check-tips">根据您的描述，为你找到以下结果，点击按钮即可打开</div>
                                    <buttonComp
                                      v-for="(item, index) in its.appCheckResult"
                                      @openAppInitiate="openAppInitiate"
                                      @open-appDialog="openAppDialog"
                                      @custom-scene="customScene"
                                      :info="item"
                                      :isAiCheck="true"
                                      :key="index" />
                                </div>
                                <div class="ai-list-text">
                                    <div class="ai-loading" v-if="its.content === '' && its.type !== 'image' && its.type !== 'video'"></div>
                                    <template v-else>
                                        <div class="img-block" v-if="its.type === 'image'">
                                            <div class="img-wrap" v-for="(item, index) in (its.content || [null])" :key="index">
                                                <div class="img-loading-mask" v-if="!its.content">
                                                    <div class="img-spinner"></div>
                                                </div>
                                                <template v-else>
                                                    <img :src="item.url" />
                                                    <div class="img-actions">
                                                        <div class="img-btn" @click="reGenImage(its, valueDoubaoIS)">
                                                            <i class="iconfont icon-zhongxinjiazai" />
                                                            再次生图
                                                        </div>
                                                        <span>|</span>
                                                        <div class="img-btn" @click="downloadImage(its.content)" :disabled="!its.content">
                                                            <i class="iconfont icon-xiazai1" />
                                                            下载
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <div class="img-block" v-else-if="its.type === 'video'">
                                            <div class="img-wrap">
                                                <div class="img-loading-mask" v-if="!its.content">
                                                    <div class="img-spinner"></div>
                                                </div>
                                                <template v-else>
                                                    <video
                                                        :src="its.content"
                                                        controls
                                                        style="width:100%;max-width:480px;display:block;"
                                                    ></video>
                                                    <div class="img-actions">
                                                        <div class="img-btn" @click="openVideoDialog(its.content)">
                                                            <i class="iconfont icon-fangda5" />
                                                            放大
                                                        </div>
                                                        <span>|</span>
                                                        <div class="img-btn" @click="downloadVideo(its.content)" :disabled="!its.content">
                                                            <i class="iconfont icon-xiazai1" />
                                                            下载
                                                        </div>
                                                    </div>
                                                </template>
                                            </div>
                                        </div>
                                        <v-md-editor v-else v-model="its.content" mode="preview"
                                        :preview-options="previewOptions"></v-md-editor>
                                    </template>
                                </div>
                                <div v-if="its.role === 'assistant' && answerOver" class="ai-button">
                                    <div class="ai-button-left">
                                        <el-tooltip style="display: none;" content="重新生成" placement="top" effect="dark">
                                            <i class="WSiconfont WSicon-shuaxin" @click="reAnswer" />
                                        </el-tooltip>
                                        <el-tooltip content="复制结果" placement="top" effect="dark">
                                            <i class="WSiconfont WSicon-fuzhiicon" @click="copyToClipboard(its.content)" />
                                        </el-tooltip>
                                        <el-tooltip content="结果插入表单" placement="top" effect="dark">
                                            <i class="WSiconfont WSicon-file-add"
                                                @mousedown="textInsert($event, its.content)" />
                                        </el-tooltip>
                                    </div>
                                    <el-button v-if="showContinueBtn" @click="continueAnswer" class="ai-button-right">继续生成</el-button>
                                </div>
                            </template>
                        </div>
                    </div>
                </el-scrollbar>
            </div>
            <!-- 问题输入区域 -->
            <div class="chat-box">
                <!-- 功能标签区域 -->
                <div class="feature-tags" ref="featureTags">
                    <ul class="feature-tags-list" ref="tagsList">
                        <li v-for="(tag, index) in visibleTags" :key="index" @click="goTemplate(tag)" ref="tagItems">
                            <i class="WSiconfont WSicon-caozuorizhi"></i>{{ tag.name }}
                        </li>
                    </ul>
                    <el-dropdown v-if="hiddenTags.length > 0" placement="top" @command="goTemplate">
                        <span class="el-dropdown-link">更多</span>
                        <template #dropdown>
                            <el-dropdown-menu>
                                <el-dropdown-item v-for="(tag, index) in hiddenTags" :key="index" :command="tag">
                                    <i class="WSiconfont WSicon-caozuorizhi"></i>{{ tag.name }}
                                </el-dropdown-item>
                            </el-dropdown-menu>
                        </template>
                    </el-dropdown>
                </div>

                <!-- 输入框区域 -->
                <div class="input-area-wrap">
                    <div class="file-list" v-if="fileList.length > 0">
                        <p class="tips">仅识别附件中的文字</p>
                        <div class="list">
                            <el-tooltip :content="file.name" placement="top" effect="dark" v-for="(file, index) in fileList" :key="index">
                                <div class="item">
                                    <div class="icon">
                                        <i class="iconfont icon-renwu1"></i>
                                    </div>
                                    <div class="file-info">
                                        <p>{{file.name}}</p>
                                        <p>{{file.type}} {{file.size}}</p>
                                    </div>
                                    <div class="btn-close" @click.stop="removeFile(index)">
                                        <i class="iconfont icon-guanbi"></i>
                                    </div>
                                </div>
                            </el-tooltip>
                        </div>
                    </div>
                    <div class="input-area" :class="{ 'input-border': queryMessage }">
                        <textarea v-model="queryMessage" v-focus ref="editor" placeholder="可以问我任何问题哦~" @keydown.enter="e => { if(!e.shiftKey) { e.preventDefault(); communicate(); } }"></textarea>
                        <div class="input-tools">
                            <div class="fl">
                                <el-select v-if="modelList.length > 1" v-model="valueModel" placeholder="请选择模型">
                                    <el-option v-for="item in modelList" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                                <el-select v-if="valueModel === 'doubao-image'" v-model="valueDoubaoIS" placeholder="请选择宽高比" style="width:75px;">
                                    <el-option v-for="item in doubanConfig.image.size" :key="item.value" :label="item.label"
                                        :value="item.value"></el-option>
                                </el-select>
                                <template v-if="valueModel === 'doubao-video'">
                                    <el-select v-model="valueDoubaoVR" placeholder="请选择宽高比" style="width:75px;">
                                        <el-option v-for="item in doubanConfig.video.ratio" :key="item" :label="item"
                                            :value="item"></el-option>
                                    </el-select>
                                    <el-select v-model="valueDoubaoVD" placeholder="请选择时长" style="width:75px;">
                                        <el-option v-for="item in doubanConfig.video.duration" :key="item" :label="item + '秒'"
                                            :value="item"></el-option>
                                    </el-select>
                                </template>
                                <aiChatBtn @confirmOk="confirmOk" @inputBlur="inputBlur" v-model:voiceConfig="voiceConfig" :isPlaying="isPlaying" @stopPlay="stopPlay" />
                                <span class="tool-item" v-if="sessions.length > 0" @click="clearHistory">清空记录</span>
                            </div>
                            <div class="fr">
                                <!-- 知识库不需要文件上传按钮 -->
                                <el-tooltip v-if="!isKnowledge" content="上传文档，快速理解并总结支持word" placement="top" effect="dark">
                                    <el-upload
                                        class="avatar-uploader"
                                        :action="$apiurl + '/confile/upload?accesstoken=' + token"
                                        :show-file-list="false"
                                        :on-success="handleAvatarSuccess"
                                        :before-upload="beforeAvatarUpload">
                                        <span class="btn-file">
                                            <el-icon><Link /></el-icon>
                                        </span>
                                    </el-upload>                                
                                </el-tooltip>
                                <template v-if="!queryMessage && answerOver">
                                    <el-tooltip content="请输入你的问题" placement="top" effect="dark">
                                        <span class="btn-submit">
                                            <el-icon><Top /></el-icon>
                                        </span>
                                    </el-tooltip>
                                </template>
                                <template v-else-if="queryMessage && answerOver">
                                    <span class="btn-submit btn-submit-high" @click="communicate">
                                        <el-icon><Top /></el-icon>
                                    </span>
                                </template>
                                <template v-else>
                                    <span class="btn-submit btn-submit-high" @click="stopThinking">
                                        <i class="WSiconfont WSicon-a-Rectangle346240893"></i>
                                    </span>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 快速回答问题列表 -->
            <div class="quick-answer-list" v-show="sessions.length === 0 && quickAnswerList.length > 0">
                <div class="inner">
                    <div class="title">快速回答</div>
                    <div class="cont">
                        <div class="quick-answer-item" v-for="(item, index) in quickAnswerList" :key="index" @click="quickAnswer(item)">
                            <img :src="$imgurl + '/' + item.iconName.img.url" v-if="item.iconName && item.iconName.img && item.iconName.img.url" />
                            <span class="quick-answer-item-text">{{ item.title }}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- HTML 预览对话框 -->
        <el-dialog
            title="预览"
            v-model="htmlPreviewVisible"
            width="80%"
            :before-close="closeHtmlPreview"
            :append-to-body="true"
            top="5vh"
        >
            <iframe
            :srcdoc="htmlPreviewContent"
            style="width: 100%; height: 70vh; border: none;"
            frameborder="0"
            ></iframe>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="openNewWindowPreview">在新窗口预览</el-button>
                    <el-button type="primary" @click="closeHtmlPreview">关 闭</el-button>
                </div>
            </template>
        </el-dialog>
        <!-- 视频放大弹窗 -->
        <el-dialog
            title="视频播放"
            v-model="videoDialogVisible"
            width="80%"
            :append-to-body="true"
            top="5vh"
            @close="closeVideoDialog"
        >
            <video
                :src="videoDialogUrl"
                controls
                autoplay
                style="width:100%;max-height:75vh;display:block;"
            ></video>
            <template #footer>
                <div class="dialog-footer">
                    <el-button @click="downloadVideo(videoDialogUrl)">下载视频</el-button>
                    <el-button type="primary" @click="closeVideoDialog">关 闭</el-button>
                </div>
            </template>
        </el-dialog>
        <AppDialog 
            :dialogInfo="dialogInfo"
            @submitCallBack="submitCallBack"
            @loadCallBack="removeMask"
            :iId="openInput.iId"
            v-model:isDetail="openInput.isDetail"
            :appId="openInput.approvalId"
            v-model:addInputShow="openAddInputShow"
            :coverVal="openInput.search"
            :datatype="openInput.datatype"
        />
    </div>
</template>
  
<script>
/* eslint-disable vue/no-mutating-props */
import { nextTick, defineAsyncComponent } from 'vue'
import { cloneDeep } from 'lodash';
import VMdEditor from '@kangc/v-md-editor';
import '@kangc/v-md-editor/lib/style/base-editor.css';
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js';
import '@kangc/v-md-editor/lib/theme/style/github.css';
import mermaid from 'mermaid';
import { getaimanageconfig, getfilecontent, getquestionknowledge, getsampleword } from '@/port/admins/ai'
import { getapprovingfilecontent } from '@/port/clientSide/oaExamine'
import common from '@/components/schoolInstrument/component/mutual/common/common'
import { dealText } from '@/api/common.js'
import Prism from 'prismjs';
import ttsMixin from '@/components/common/chat/common/tts.mixin.js';
import chatMixin from '@/components/common/chat/common/chat.mixin.js';
import 'prismjs/components/prism-javascript';
import 'prismjs/components/prism-typescript';
import 'prismjs/components/prism-markup';
import 'prismjs/components/prism-markdown';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-css';
import 'prismjs/components/prism-bash';

const customHighlight = (str, lang) => {
  if (!str) return `<pre><code></code></pre>`;

  let highlightLang = lang && typeof lang === 'string' ? lang.toLowerCase() : '';
  if (highlightLang.startsWith('html') || highlightLang === 'xml') {
    highlightLang = Prism.languages.html ? 'html' : (Prism.languages.markup ? 'markup' : 'html');
  }
  if (!highlightLang || !Prism.languages[highlightLang]) {
    highlightLang = Prism.languages.markup ? 'markup' : highlightLang;
  }

  const escapeHtml = (text) => {
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
  };

  if (!highlightLang || !Prism.languages[highlightLang]) {
    return `<pre class="language-text"><code>${escapeHtml(str)}</code></pre>`;
  }

  try {
    const highlighted = Prism.highlight(str, Prism.languages[highlightLang], highlightLang);
    return `<pre class="language-${highlightLang}"><code class="language-${highlightLang}">${highlighted}</code></pre>`;
  } catch (e) {
    console.warn('Code highlighting failed:', e);
    return `<pre class="language-${highlightLang}"><code>${escapeHtml(str)}</code></pre>`;
  }
};

// 配置 Mermaid
mermaid.initialize({
  startOnLoad: false, // 设置为 false，由 v-md-editor 控制渲染
  theme: 'default',
  flowchart: {
    useMaxWidth: false,
  },
  securityLevel: 'loose',
});

const setupMarkdownExtension = () => {
    VMdEditor.use(githubTheme, {
        Prism,
        extend(md) {
            // 覆盖默认高亮处理器
            md.set({
                highlight: customHighlight
            });

            // Mermaid 插件
            const defaultRender = md.renderer.rules.fence;
            
            md.renderer.rules.fence = (tokens, idx, options, env, self) => {
                const token = tokens[idx];
                if (!token) {
                    return '<pre><code></code></pre>';
                }

                const lang = (token.info && typeof token.info === 'string' && token.info.trim)
                ? token.info.trim()
                : '';
                const content = token.content || '';

                // 如果是 mermaid 代码块
                if (lang === 'mermaid') {
                    try {
                        // 生成唯一 ID
                        const id = 'mermaid-' + Math.random().toString(36).substr(2, 9);
                        
                        // 返回包含 mermaid 代码的容器
                        return `<div class="mermaid-container" data-mermaid-id="${id}">
                            <div class="mermaid-code" style="display: none;">${content}</div>
                            <div id="${id}" class="mermaid-chart">正在渲染图表...</div>
                        </div>`;
                    } catch (err) {
                        // return `<pre><code>Mermaid 渲染错误: ${err.toString()}</code></pre>`;
                    }
                }

                const lowerLang = (lang || '').toLowerCase();

                const looksLikeHtml = /<!DOCTYPE\s+html>|<html[\s>]|<head[\s>]|<body[\s>]/i.test(content);

                // 如果是 HTML 代码块，添加loading状态和切换功能
                if ((lowerLang.startsWith('html') || (!lowerLang && looksLikeHtml)) && content) {
                    const htmlId = `html-code-${Date.now()}-${idx}`;
                    const highlightLang = Prism.languages.html ? 'html' : (Prism.languages.markup ? 'markup' : 'html');
                    const highlightedCode = customHighlight(content, highlightLang);

                    // 检测是否在流式渲染中（通过检查answerOver状态，这里需要通过全局变量或闭包传递）
                    // 暂时使用一个标记来判断，后续会在渲染完成后更新
                    // const isStreaming = true; // 默认在流式渲染中

                    // Loading状态的div
                    const loadingHtml = `<div class="html-code-loading" data-html-id="${htmlId}">
                        <div class="html-code-loading-content">
                        <div class="html-code-loading-text">
                            <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/robot-img.gif" alt="" />
                            正在生成展示效果，预计2-5分钟，请耐心等待...
                        </div>
                        </div>
                    </div>`;

                    // 完成状态的div（初始隐藏）
                    const completedHtml = `<div class="html-code-completed" data-html-id="${htmlId}" style="display: none;">
                        <div class="html-code-completed-content">
                        <div class="html-code-completed-text">
                            <img src="https://bigdata.topeti.com/PCRepository/mainPlatform/robot-img1.png" alt="" />
                            已生成完毕可点击查看
                        </div>
                        <div class="html-code-actions" style="position:inherit;">
                            <button class="html-code-btn html-code-download" data-action="download">
                            <i class="WSiconfont WSicon-a-3"></i>下载
                            </button>
                            <button class="html-code-btn html-code-preview" data-action="preview">
                            <i class="WSiconfont WSicon-a-1"></i>预览
                            </button>
                        </div>
                        <i class="html-code-toggle-icon WSiconfont WSicon-a-4" data-action="toggle"></i>
                        </div>
                    </div>`;

                    // 代码容器（初始隐藏），包含高亮代码和按钮
                    const codeActionsHtml = `<div class="html-code-actions">
                        <button class="html-code-btn html-btn-result html-code-download" data-action="download">
                        <i class="WSiconfont WSicon-a-3"></i>下载
                        </button>
                        <button class="html-code-btn html-btn-result html-code-copy" data-action="copy">
                        <i class="WSiconfont WSicon-a-2"></i>复制
                        </button>
                        <button class="html-code-btn html-btn-result html-code-preview" data-action="preview">
                        <i class="WSiconfont WSicon-a-1"></i>预览
                        </button>
                    </div>`;

                    const codeContainer = `<div class="html-code-container" data-html-id="${htmlId}" style="display: none;">
                        ${codeActionsHtml}
                        ${highlightedCode}
                    </div>`;

                    return `<div class="html-code-block-wrapper" data-html-id="${htmlId}" data-streaming="true">
                        ${loadingHtml}
                        ${completedHtml}
                        ${codeContainer}
                    </div>`;
                }                        

                return defaultRender(tokens, idx, options, env, self);
            };
        }
    });

    console.log('Markdown扩展已注册');
};


export default {
    name: "chatBox",
    mixins: [common, ttsMixin, chatMixin],
    components: {
        VMdEditor,
        AppDialog: defineAsyncComponent(() => import('@/components/schoolInstrument/mixins/AppDialog.vue')),
        buttonComp: defineAsyncComponent(() => import('@/components/schoolInstrument/component/mutual/component/button/index.vue')),
    },
    props: {
        // 模板配置
        robotConfig: {
            type: Object,
            default: () => ({})
        },
        // 模型配置
        modelConfig: {
            type: Array,
            default: () => []
        },
        // 表单数据
        formdata: {
            type: Object,
            default: () => ({})
        },
        // 表单控件配置
        ruleList: {
            type: Array,
            default: () => []
        },
        // 应用id
        approvalId: {
            type: Number,
            default: null
        },
        approvingId: {
            type: Number,
            default: null
        },        
        // 是否是知识库使用
        isKnowledge: {
            type: Boolean,
            default: false
        },
        // 当前使用的知识库
        knowledgeInfo: {
            type: Object,
            default: () => { return {} }
        },
        customDeskInfo: {
            type: Object,
            default: () => { return {} }
        },
        // 文件解析配置信息
        appfile: {
            type: Object,
            default: () => ({})
        },
        // 应用参数
        appCustomData: {
            type: Array,
            default: () => []
        },
        // 样式配置
        appAgentConfig: {
            type: Object,
            default: () => ({})
        },
    },
    watch: {
        // 监听会话列表变化
        sessions: {
            handler() {
                this.updateScrollButtons();
            },
            deep: true
        },
        robotConfig: {
            handler(newVal) {
                console.log("newVal==", newVal);
                this.getAiName()
                if (newVal && newVal.list) {
                    this.tags = [...newVal.list];
                    this.param = newVal.param
                }
                this.systemSwitch = newVal.systemSwitch === 0 ? 0 : 1
                this.quickAnswerList = newVal.questionData || []
                this.appCheckList = newVal.appCheckList || []
            },
            deep: true,
            immediate: true
        },
        customDeskInfo: {
            handler(newVal) {
                console.log("newVal==", newVal);
                if (newVal && newVal.paramQuesConfig && newVal.paramQuesConfig.dataList) {
                    this.tags = [...newVal.paramQuesConfig.dataList];
                    this.param = newVal.paramQuesConfig.param
                    this.systemSwitch = newVal.paramQuesConfig.systemSwitch
                }
                if (newVal && newVal.valueKnowledge && newVal.valueKnowledge.length > 0) {
                    if (Array.isArray(newVal.valueKnowledge)) {
                        // 已经是数组，直接赋值
                        this.valueKnowledge = newVal.valueKnowledge
                    } else if (typeof newVal.valueKnowledge === 'string') {
                        try {
                            // 尝试将JSON字符串解析为数组
                            const parsed = JSON.parse(newVal.valueKnowledge)
                            if (Array.isArray(parsed)) {
                                this.valueKnowledge = parsed
                            } else {
                                // 如果不是数组，设置为空数组或包含该值的数组
                                this.valueKnowledge = [parsed]
                            }
                        } catch (e) {
                            // 解析失败，设置为包含原始字符串的数组
                            console.error("解析valueKnowledge失败:", e)
                            this.valueKnowledge = [newVal.valueKnowledge]
                        }
                    } else {
                        // 其他类型，转换为数组
                        this.valueKnowledge = [newVal.valueKnowledge]
                    }
                }
                if (newVal && newVal.paramQuesConfig && newVal.paramQuesConfig.questionData) {
                    this.quickAnswerList = newVal.paramQuesConfig.questionData
                }
            },
            deep: true,
            immediate: true
        },
        'dialogInfo.isVisible': {
            handler(newVal) {
                if (!newVal) {
                    this.saveSessionHistory();
                }
            }
        },
        tags: {
            handler() {
                this.$nextTick(() => {
                    this.calculateVisibleTags();
                });
            },
            deep: true
        },
        appAgentConfig: {
            handler(newVal) {
                if(Object.keys(newVal).length !== 0){
                    this.agentConfig = newVal
                }
            },
            deep: true,
            immediate: true
        },
    },
    data() {
        return {
            isHistoryShown: false,
            inputMessage: '',
            tags: [], // 选择的ai模板
            param: {}, // 预设参数
            modelList: [], // 模型列表
            showHistoryBtn: false, // 是否显示历史记录按钮
            valueModel: 'yiwen',
            fileList: [], // 上传文件列表
            sessionsHistory: [], // 当前历史会话记录
            sessionsEdit: [], // 存储编辑前的临时会话记录
            historymsg: [], // 缓存中的历史记录
            agentConfig: {}, //智能体配置
            valueKnowledge: [], // 已选择知识库
            quickAnswerList: [], // 快速回答问题列表
            systemSwitch: 1, //精确调参
            currentSessionIndex: 0, // 当前显示的会话索引
            token: localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : '',
            // 所有模型列表
            optionsModel: [
                {
                    name: 'AI易问',
                    value: 'yiwen',
                    number: 0,
                    label: 'AI易问'
                },
                {
                    name: 'AI易言',
                    value: 'yiyan',
                    number: 1,
                    label: 'AI易言'
                },
                {
                    name: 'AI易画',
                    value: 'yihua',
                    number: 2,
                    label: 'AI易画'
                },
                {
                    name: 'AI易写',
                    value: 'zixun',
                    number: 3,
                    label: 'AI易写'
                },
                {
                    name: 'AI易录',
                    value: 'yilu',
                    number: 4,
                    label: 'AI易录'
                },
                {
                    name: '电信 DeepSeek 671B',
                    value: 'dx-deepseek671b',
                    number: 5,
                    label: 'dx-deepseek671b'
                },
                {
                    name: '官方 DeepSeek R1',
                    value: 'deepseek-reasoner',
                    number: 6,
                    label: 'deepseek-reasoner'
                },
                {
                    name: '官方 DeepSeek V3',
                    value: 'deepseek-chat',
                    number: 7,
                    label: 'deepseek-chat'
                },
                {
                    name: '火山生图',
                    value: 'doubao-image',
                    number: 8,
                    label: 'doubao-image'
                },
                {
                    name: '火山视频',
                    value: 'doubao-video',
                    number: 9,
                    label: 'doubao-video'
                }
            ],
            // 火山生图、视频自定义字段
            doubanConfig: {
                image: {
                    size: [
                        {
                            label: '1:1',
                            value: '2048x2048',
                        },
                        {
                            label: '4:3',
                            value: '2304x1728',
                        },
                        {
                            label: '3:4',
                            value: '1728x2304',
                        },
                        {
                            label: '16:9',
                            value: '2848x1600',
                        },
                        {
                            label: '9:16',
                            value: '1600x2848',
                        },
                        {
                            label: '3:2',
                            value: '2496x1664',
                        },
                        {
                            label: '2:3',
                            value: '1664x2496',
                        },
                        {
                            label: '21:9',
                            value: '3136x1344',
                        }
                    ]
                },
                video: {
                    ratio: ['16:9', '4:3', '1:1', '3:4', '9:16', '21:9'],
                    duration: Array.from({ length: 9 }, (_, i) => i + 4) // 生成4-12的数组
                }
            },
            valueDoubaoIS: '2304x1728',
            valueDoubaoVR: '4:3',
            valueDoubaoVD: 5,
            skin: {
                avatar: '', //ai形象-头像
                sloganText: '', //ai形象-slogan
                descriptionText: '', //ai形象-文案        
                sloganStyle: {
                fontSize: '26px',
                fontFamily: '微软雅黑',
                fontWeight: 'normal', // 是否加粗
                fontStyle: 'normal', // 是否斜体
                textDecoration: 'none', // 是否下划线
                color: 'rgba(0, 0, 0, 1)', // 选择的颜色
                textAlign: 'left' // 位置排版
                },
                descriptionStyle: {
                fontSize: '14px',
                fontFamily: '微软雅黑',
                fontWeight: 'normal', // 是否加粗
                fontStyle: 'normal', // 是否斜体
                textDecoration: 'none', // 是否下划线
                color: 'rgba(64, 64, 64, 1)', // 选择的颜色
                textAlign: 'left' // 位置排版
                }
            },
            queryMessage: '', // 输入框内容
            sendMessage: '', // 发送内容
            thinking: false, // 思考状态
            answerOver: true, // 回答问题状态
            showContinueBtn: false, // 是否显示继续生成按钮
            renderBuffer: [], // 渲染缓冲区
            isRendering: false, // 新增渲染状态
            dialogInfo: {},
            previewOptions: {
                linkify: true,
                breaks: true,
                html: true,
                typographer: true,
                highlight: (code, lang) => {
                return customHighlight(code, lang || '');
                }
            },
            // HTML 预览对话框状态
            htmlPreviewVisible: false,
            htmlPreviewContent: '',
            htmlPreviewIframeSrc: '',
            sessions: [], // 对话记录
            timer: null, // 添加计时器变量
            startTime: null, // 添加开始时间变量
            abortController: null, // 添加 AbortController
            showScrollButtons: false,
            showUpButton: false,
            showDownButton: true,
            visibleTagCount: 0, // 可见标签数量
            showMask: false, //load遮罩层是否显示
            isKnowledgeStop: false, // 知识库暂停
            userHasScrolled: false, // 用户滚动状态（是否滚动过）
            appCheckList: [], // 应用检索对象
            appCheckResult: [], // 应用检索对象结果
            openInput: {},
            openAddInputShow: false,
            videoDialogVisible: false,
            videoDialogUrl: ''
        }
    },
    created() {                
        // 获取历史记录
        this.getHistory()
    },
    computed: {
        visibleTags() {
            return this.tags.slice(0, this.visibleTagCount);
        },
        hiddenTags() {
            return this.tags.slice(this.visibleTagCount);
        },
        isReasonModel() {
            const m = (this.valueModel || '').trim();
            return m === 'deepseek' || m === 'yiwen' || m === 'deepseek-reasoner';
        }
    },
    methods: {
        openAppInitiate ({approvalId, name, search, iId, id, datatype, popUps, pageType}) {
            this.openInput = {
                isVisible: true,
                approvalId: approvalId,
                name: name,
                search: search,
                iId: iId,
                isDetail: [15, 16, 23, 24, 25].includes(iId) /*|| iId === 13 || iId === 14*/,
                id: id || '',
                datatype: datatype
            }
            const obj = {
                2: 'dialog',
                3: 'new',
                4: 'old',
                5: 'rightdia'
            }
            this.dialogInfo = {
                isVisible: true,
                dialogName: name,
                dialogWidth: popUps.w + 'px',
                dialogHeight: popUps.h + 'px',
                openType: obj[popUps.open],
                customSize: popUps.customSize,
                diaSize: popUps.diaSize,
                pageType: pageType || ''
            }
            this.openAddInputShow = true
        },
        customScene (val) {
            const { url, query, open, popUps } = val
            const obj = {
            2: 'dialog',
            3: 'new',
            4: 'old',
            5: 'rightdia'
            }
            this.dialogInfo = {
            isVisible: true,
            dialogName: query.name,
            dialogWidth: popUps.w + 'px',
            dialogHeight: popUps.h + 'px',
            openType: obj[open],
            dialogUrl: url,
            customSize: popUps.customSize,
            diaSize: popUps.diaSize,
            }
        },
        getBtnInfo (item) {
            const obj = {
                info: {
                    icon: item.icon,
                    btnName: item.aliasName
                }
            }
            if (item.type === 'page') {
                obj.info.bindingFunction = 'custom-scene'
                obj.info.customScene = {
                    id: item.id,
                    params: item.name
                }
                obj.info.insideInfo = {
                    open: 2,
                    popUps: {
                        h: 800,
                        w: 1700,
                    }
                }

            } else {
                obj.info.bindingFunction = 'inside'
                obj.info.insideInfo = {
                    link: 2,
                    open: 2,
                    appIid: item.appIid,
                    datatype: item.datatype,
                    appid: item.id,
                    linked: [],
                    customize: [],
                    popUps: {
                      h: 800,
                      w: 1700,
                    }
                }
            }
            return obj
        },
        isInquire(){
            let textInfo = localStorage.getItem('currentTranscription');
            if(textInfo){
                textInfo = JSON.parse(textInfo);
                if(textInfo.isAi){
                    this.queryMessage = textInfo.text;
                    setTimeout(()=>{
                        this.$nextTick(this.communicate)
                    }, 500)
                }
                localStorage.removeItem('currentTranscription');
            }
        },      
        inputBlur() {
            this.$refs.editor.blur()
        },
        confirmOk() {
            this.communicate()
        },
        // 获取ai名称配置信息
        async getAiName() {
            const res = await getaimanageconfig()
            if (res.code === 0) {
                this.optionsModel.forEach(ai => {
                    res.data.forEach(item => {
                        if (ai.number === item.number) {
                            ai.name = item.name;
                        }
                    });
                });
                if (this.modelConfig && this.modelConfig.length > 0) {
                    // 根据 number 筛选 optionsModel
                    this.modelList = this.optionsModel.filter(model =>
                        this.modelConfig.includes(model.number)
                    ).map(model => ({
                        value: model.value,
                        label: model.name
                    }));

                    console.log("Filtered modelList00:", this.modelList);

                    // 如果当前选中的模型不在筛选结果中，设置为第一个可用模型
                    if (this.modelList.length > 0 && !this.modelList.some(m => m.value === this.valueModel)) {
                        this.valueModel = this.modelList[0].value;
                    }
                }
                //ai中台配置模型选项
                if (this.customDeskInfo && this.customDeskInfo.check && this.customDeskInfo.check.length > 0) {
                    // 根据 number 筛选 optionsModel
                    this.modelList = this.optionsModel.filter(model =>
                    this.customDeskInfo.check.includes(model.label)
                    ).map(model => ({
                        value: model.value,
                        label: model.name
                    }));
                    // 如果当前选中的模型不在筛选结果中，设置为第一个可用模型
                    if (this.modelList.length > 0 && !this.modelList.some(m => m.value === this.valueModel)) {
                        this.valueModel = this.modelList[0].value;
                    }
                }
                //ai中台配置样式
                if (this.customDeskInfo && this.customDeskInfo.agentConfig) {
                    this.agentConfig = this.customDeskInfo.agentConfig
                }
                // 处理AI形象配置
                const skinConfig = res.data.find(item => item.number === 99);
                if (skinConfig && skinConfig.info) {
                    this.skin = {
                        ...this.skin,
                        ...skinConfig.info
                    };
                    if(this.skin.avatar === ''){
                        this.skin.avatar = 'https://bigdata.topeti.com/PCRepository/middleground/abilityManagement/default-robot.png'
                    }
                }
                else{
                    this.skin.avatar = 'https://bigdata.topeti.com/PCRepository/middleground/abilityManagement/default-robot.png'
                    this.skin.sloganText = '我是AI小易，需要什么帮助？'
                    this.skin.descriptionText = '全面支持自定义模型训练，知识库建设，打造专属AI'
                }
            } else {
                this.$message.error(res.msg);
            }
        },
        // 获取历史记录
        getHistory() {
            // 优先使用 approvalId，其次使用 chatId
            const historyKey = this.approvalId || this.customDeskInfo.chatId;
            
            if (!historyKey) return;
            try {
                let historymsg = localStorage.getItem('historymsg');
                if (!historymsg) return;

                let historyObj = JSON.parse(historymsg);
                // 判断是否有 historymsg 数据
                if (historyObj && historyObj[historyKey]) {
                    let sessionHistory = JSON.parse(historyObj[historyKey]);
                    if (sessionHistory && sessionHistory.length > 0) {
                        this.historymsg = sessionHistory;
                        this.showHistoryBtn = true;
                    }
                }
            } catch (error) {
                // 如果出错，清空历史记录
                this.historymsg = [];
                this.showHistoryBtn = false;
            }
        },
        viewHistory() {
            if (this.sessions.length >= this.historymsg.length) {
                // 如果当前会话包含历史记录，则移除历史记录
                this.sessions = this.sessions.slice(this.historymsg.length);
                this.isHistoryShown = false;
            } else {
                // 将历史记录添加到当前会话的最前面
                this.sessions = [...this.historymsg, ...this.sessions];
                this.isHistoryShown = true;
            }
        },
        // 思考状态展开折叠
        toggleThinking(event) {
            // 获取当前点击的 ai-think 元素的父元素
            const parentEl = event.target.closest('.ai-list-center');
            console.log("parentEl==", parentEl);
            if (!parentEl) return;

            // 在父元素中查找包含 data-v-md-line="1" 的元素
            const thinkingContent = parentEl.querySelector('div[data-v-md-line="1"]');
            console.log("thinkingContent==", thinkingContent);
            if (thinkingContent.style.display === 'none') {
                thinkingContent.style.display = 'block';
            } else {
                thinkingContent.style.display = 'none';
            }
            if (thinkingContent) {
                event.target.classList.toggle('hide');
            }
        },
        // 停止回答
        stopThinking() {
            // 中止请求
            if (this.abortController) {
                this.abortController.abort();
                this.stopPlay()
            }
            if (this.isKnowledge && this.knowledgeInfo.id) {
                this.isKnowledgeStop = true
            }
        },
        // 编辑内容
        editContent(its) {
            // 将其他所有消息的编辑状态设为 false
            this.sessions.forEach(session => {
                if (session !== its) {
                    session.edit = false;
                }
            });
            this.sessionsEdit.push(cloneDeep(this.sessions));

            // 过滤掉隐藏的预设参数内容
            const content = its.content.replace(/<div style='display: none;'>.*?<\/div>/g, '');
            const filteredContent = this.filterHtmlTags(content);
            its.content = filteredContent;

            // 设置当前消息的编辑状态为 true
            its.edit = true;
            
            // 确保编辑框在下一个 tick 显示后获得焦点
            this.$nextTick(() => {
                const textarea = document.querySelector('.ai-list-text-edit textarea');
                if (textarea) {
                    textarea.focus();
                }
            });
        },
        // 取消编辑
        cancelEdit(its) {
            // 将其他所有消息的编辑状态设为 false
            this.sessions.forEach(session => {
                if (session !== its) {
                    session.edit = false;
                }
            });
            // 将当前消息的编辑状态设为 false
            its.edit = false;
            this.sessionsEdit = []
        },
        // 切换历史会话
        switchSession(direction) {
            // 如果当前会话未保存，先保存
            if (this.currentSessionIndex === this.sessionsHistory.length) {
                this.sessionsHistory.push(cloneDeep(this.sessions));
            }

            // 计算新的索引
            let newIndex = this.currentSessionIndex;
            if (direction === 'prev' && this.currentSessionIndex > 0) {
                newIndex--;
            } else if (direction === 'next' && this.currentSessionIndex < this.sessionsHistory.length - 1) {
                newIndex++;
            }

            // 如果索引发生变化，更新显示的会话
            if (newIndex !== this.currentSessionIndex) {
                this.currentSessionIndex = newIndex;
                this.sessions = [...this.sessionsHistory[this.currentSessionIndex]];
            }
        },
        // 发送编辑后的问题
        sendEdit(its) {
            // 找到当前编辑消息在sessions中的索引
            const editIndex = this.sessions.findIndex(session => session === its);
            if (editIndex === -1) return;

            // 保存当前会话到历史记录
            console.log("this.sessionsEdit==", cloneDeep(this.sessionsEdit));
            this.sessionsHistory = this.sessionsEdit;
            
            // 只保留到当前编辑消息的内容
            this.sessions = this.sessions.slice(0, editIndex + 1);
            
            // 更新当前会话索引为最新
            this.currentSessionIndex = this.sessionsHistory.length;

            // 清除编辑状态
            its.edit = false;
            this.sessionsEdit = []

            // 重新生成
            this.startAi();
        },
        // 重新生成
        reAnswer() {
            // 获取最后一条会话的前一条用户输入
            if (this.sessions.length >= 2) {
                const lastUserMessage = this.sessions[this.sessions.length - 2];

                // 确保是用户消息
                if (lastUserMessage.role === 'user') {
                    // 删除最后一条助手回复
                    this.sessions.pop();

                    // 重新执行 startAi
                    this.startAi();
                }
            }
        },
        // 复制结果
        copyToClipboard(content) {
            if (typeof content === 'object') {
                content = content.imgUrl;
            } else {
                // 过滤掉思考内容
                content = content.replace(/<div class="think">[\s\S]*?<\/div>/g, '');
            }

            const self = this;

            if (window.clipboardData) {
                window.clipboardData.setData("text", content);
                self.$message.success('复制成功！');
            } else {
                (function (content) {
                    document.oncopy = function (e) {
                        e.clipboardData.setData("text", content);
                        e.preventDefault();
                        document.oncopy = null;
                        self.$message.success('复制成功！');
                    };
                })(content);
                document.execCommand("Copy");
            }
        },
        // 插入答案
        textInsert(event, content) {
            // 过滤掉思考内容
            content = content.replace(/<div class="think">[\s\S]*?<\/div>/g, '');
            this.$emit('textInsert', { event: event, content: content });
        },
        // 点击打开模板
        async goTemplate(tag) {
            console.log("goTemplate clicked, tag=", tag);
            if (!tag.insideInfo) return;
            if (this.thinking) {
                this.$message.warning('正在努力分析中，请稍后再试')
                return
            }
            const item = tag.insideInfo;
            item.channel = 'appAi';
            if (!this.dealInside) return;
            // 遍历查询是否有配置“数据解析”字段，如果有配的话需要调接口获取解析的值
            if(this.appfile && this.appfile.open && item.linked && item.linked.length > 0){
                const linkedFields = item.linked;
                let shouldDealInside = true; // 标记是否需要执行 dealInside
                console.log("linkedFields==",linkedFields);
                for (const linkedField of linkedFields) {
                    const valueKey = `${linkedField.title}_${linkedField.type}`;
                    if(valueKey === 'data-analysis_text'){
                        const obj = {
                            approvalId: this.approvalId,
                            approvingId: this.approvingId
                        }
                        const res = await getapprovingfilecontent(obj)
                        if (res.code === 0) {
                            this.formdata['data-analysis_text'] = res.data
                            this.dealInside(this.formdata, item);
                            shouldDealInside = false;
                        }
                        break;
                    }
                }
                if (shouldDealInside) {
                    this.dealInside(this.formdata, item);
                }
            }
            // 中台配置预设参数
            else if(this.customDeskInfo && this.customDeskInfo.paramQuesConfig && this.customDeskInfo.paramQuesConfig.dataList && this.customDeskInfo.paramQuesConfig.customData){
                const { customData } = this.customDeskInfo.paramQuesConfig;
                if (customData.length > 0) {
                    customData.forEach(item => {
                        const key = `${item.title}_${item.type}`;
                        this.formdata[key] = item.value;
                    });
                }
                this.dealInside(this.formdata, item);
            }
            else{
                this.dealInside(this.formdata, item);
            }
            console.log("this.approvalId==",this.approvalId,this.approvingId);
        },
        // 模板ai编辑后回调
        async submitCallBack(val){
            const sessionCont = val.sessions[0].role === 'user' ? this.filterHtmlTags(val.sessions[0].content) : this.filterHtmlTags(val.sessions[1].content)
            // 第一段对话加入预设参数
            if (Object.prototype.hasOwnProperty.call(this.param, 'bindinf') && this.param.bindinf && this.systemSwitch === 0) {
                const systemContent = await this.getSystemMessage();
                console.log("systemContent==",systemContent)
                this.sendMessage = "<div style='display: none;'>" + systemContent + "</div>"  + sessionCont;
            }
            else {
                this.sendMessage = sessionCont;
            }

            // 如果上传了文件，将文件内容添加到发送消息中
            // if(this.fileList.length > 0){
            //     const fileCount = this.fileList.length;
            //     const fileContents = this.fileList.map((file, index) => 
            //         `文档${index + 1}:${file.name}\n内容:${file.data}`
            //     ).join('\n');
            //     this.sendMessage = this.sendMessage + `\n\n以下是我上传的${fileCount}份文档：\n${fileContents}`;
            // }
            if(this.sessions.length === 0 && this.systemSwitch === 1){
                const systemContent = await this.getSystemMessage();
                if (systemContent) {
                    this.sessions.push({
                        role: 'system',
                        content: systemContent
                    });
                }
            }

            // 用户询问
            this.sessions.push({
                role: 'user',
                content: this.sendMessage,
                id: Date.now(),
                edit: false,
                showQuestion: val.showQuestion
            })
            this.dialogInfo.isVisible = false
            this.removeMask()
            this.startAi()
        },
        // 渲染 Mermaid 图表
        renderMermaidCharts() {
            this.$nextTick(() => {
                setTimeout(() => {
                    const mermaidContainers = document.querySelectorAll('.mermaid-container');
                    // console.log('找到 Mermaid 容器数量:', mermaidContainers.length);
                    
                    mermaidContainers.forEach(container => {
                        const codeElement = container.querySelector('.mermaid-code');
                        const chartElement = container.querySelector('.mermaid-chart');
                        
                        if (!codeElement || !chartElement || chartElement.classList.contains('rendered')) {
                            return;
                        }
                        
                        const mermaidCode = codeElement.textContent;
                        // console.log('Mermaid 代码:', mermaidCode);
                        
                        if (!mermaidCode.trim()) {
                            chartElement.innerHTML = '<div class="mermaid-error">图表代码为空</div>';
                            return;
                        }
                        
                        try {
                            // 设置 mermaid 代码
                            chartElement.textContent = mermaidCode;
                            chartElement.classList.add('mermaid');
                            
                            // 检查 mermaid 版本并调用相应的方法
                            if (mermaid.init && typeof mermaid.init === 'function') {
                                // Mermaid 8.x 版本 - 返回 Promise
                                const initResult = mermaid.init(undefined, chartElement);
                                
                                if (initResult && typeof initResult.then === 'function') {
                                    // 如果是 Promise
                                    initResult.then(() => {
                                        console.log('Mermaid 图表渲染成功');
                                        chartElement.classList.add('rendered');
                                        // this.addMermaidCopyButton(container, mermaidCode);
                                    }).catch(err => {
                                        console.error('Mermaid 初始化失败:', err);
                                        this.handleMermaidError(chartElement, err);
                                    });
                                } else {
                                    // 如果是同步方法（Mermaid 9.x+）
                                    // console.log('Mermaid 同步初始化完成');
                                    chartElement.classList.add('rendered');
                                    // this.addMermaidCopyButton(container, mermaidCode);
                                }
                            } else {
                                // 使用 render 方法作为备选
                                this.renderMermaidWithRenderAPI(chartElement, mermaidCode, container);
                            }
                        } catch (err) {
                            console.error('Mermaid 处理异常:', err);
                            this.handleMermaidError(chartElement, err);
                        }
                    });
                }, 100);
            });
        },

        // 添加备选渲染方法
        renderMermaidWithRenderAPI(chartElement, mermaidCode) {
            try {
                // 生成唯一 ID
                const id = 'mermaid-' + Math.random().toString(36).substr(2, 9);
                chartElement.id = id;
                
                if (mermaid.render && typeof mermaid.render === 'function') {
                    mermaid.render(id, mermaidCode).then(({ svg }) => {
                        chartElement.innerHTML = svg;
                        chartElement.classList.add('rendered');
                        // this.addMermaidCopyButton(container, mermaidCode);
                    }).catch(err => {
                        console.error('Mermaid render 方法失败:', err);
                        this.handleMermaidError(chartElement, err);
                    });
                } else {
                    throw new Error('Mermaid 渲染方法不可用');
                }
            } catch (err) {
                this.handleMermaidError(chartElement, err);
            }
        },
        openAppDialog (val) {            
            // this.$set(this, 'dialogInfo', val)
            this.dialogInfo = val
            this.showMask = true
        },
        removeMask() {
            this.showMask = false
        },
        // 清空记录
        clearHistory() {
            this.$confirm('确定要清空记录吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sessions = [];
                this.sessionsHistory = [];
                this.currentSessionIndex = 0;
                this.showHistoryBtn = false;
                this.$message({
                    type: 'success',
                    message: '记录清空成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消'
                });
            });
        },
        // 过滤HTML标签的方法
        filterHtmlTags(str) {
            if (!str) return '';
            // 移除所有HTML标签
            return str.replace(/<[^>]+>/g, '')
                // 替换HTML实体
                .replace(/&nbsp;/g, ' ')
                .replace(/&lt;/g, '<')
                .replace(/&gt;/g, '>')
                .replace(/&amp;/g, '&')
                .replace(/&quot;/g, '"')
                // 移除多余空格
                .replace(/\s+/g, ' ')
                .trim();
        },
        // 替换 bindinf 中的占位符
        async replaceBindinfPlaceholders(text) {
            if (!text || typeof text !== 'string') return text;
            const placeholderRegex = /\$\{([^_]+)_([^}]+)\}/g;
            let lastIndex = 0;
            let result = '';
            let match;

            while ((match = placeholderRegex.exec(text)) !== null) {
                const [fullMatch, varName, varType] = match;
                result += text.slice(lastIndex, match.index);
                const replacement = await this.resolveBindinfPlaceholder(fullMatch, varName, varType);
                result += replacement;
                lastIndex = match.index + fullMatch.length;
            }

            result += text.slice(lastIndex);
            return result;
        },
        async resolveBindinfPlaceholder(fullMatch, varName, varType) {
            try {
                if (varType === 'dataForm') {
                    if (!Array.isArray(this.ruleList) || !this.formdata) {
                        console.warn('ruleList 或 formdata 缺失，无法替换占位符');
                        return '';
                    }

                    const matchedRule = this.ruleList.find(rule => rule.name === varName);
                    if (!matchedRule) {
                        console.warn(`未找到匹配的规则: ${varName}`);
                        return '';
                    }

                    const formdataKey = `${matchedRule.title}_${matchedRule.type}`;
                    if (!Object.prototype.hasOwnProperty.call(this.formdata, formdataKey)) {
                        console.warn(`formdata 中未找到对应的键: ${formdataKey}`);
                        return '';
                    }

                    const formdataValue = this.formdata[formdataKey];
                    if (formdataValue === undefined || formdataValue === null) {
                        console.warn(`formdata 中对应的值为空: ${formdataKey}`);
                        return '';
                    }

                    if (matchedRule.type === 'file') {
                     const fileContent = await this.getFilePlaceholderValue(formdataValue);
                        return fileContent !== '' ? fileContent : '';
                    }

                    return this.normalizeBindinfValue(formdataValue);
                }

                if (varType === 'custom') {
                    if (Array.isArray(this.appCustomData) && this.appCustomData.length > 0) {
                        const matchedCustom = this.appCustomData.find(item => item && item.name === varName);
                        if (matchedCustom && matchedCustom.value !== undefined && matchedCustom.value !== null) {
                            return String(matchedCustom.value);
                        }
                    }
                    if (this.param && this.param.customData && this.param.customData[varName] !== undefined && this.param.customData[varName] !== null) {
                        return String(this.param.customData[varName]);
                    }
                    console.warn(`customData 中未找到对应的值: ${varName}`);
                    return '';
                }

                console.warn(`未处理的变量类型: ${varType}`);
                return '';
            } catch (error) {
                console.error('替换占位符时出错:', error, { varName, varType });
                return '';
            }
        },
        async getFilePlaceholderValue(formdataValue) {
            if (formdataValue === undefined || formdataValue === null) {
                return '';
            }

            const files = Array.isArray(formdataValue) ? formdataValue : [formdataValue];
            const contents = [];

            for (const file of files) {
                if (!file) continue;

                let textContent = file.text;
                if (!textContent) {
                    const filePath = file.response || file.url;
                    if (filePath) {
                        const normalizedPath = filePath.replace(/^\/?userfiles\//, '');
                        try {
                            const fileContent = await this.getfileCont(normalizedPath);
                            if (fileContent !== false && fileContent !== undefined && fileContent !== null) {
                                textContent = fileContent;
                                if (typeof this.$set === 'function') {
                                    this.$set(file, 'text', fileContent);
                                } else {
                                    file.text = fileContent;
                                }
                            }
                        } catch (error) {
                            console.error('获取文件内容失败:', error, filePath);
                        }
                    }
                }

                if (textContent) {
                    contents.push(textContent);
                } else if (file.name) {
                    contents.push(file.name);
                }
            }

            return contents.join('\n');
        },
        normalizeBindinfValue(value) {
            if (value === undefined || value === null) {
                return '';
            }

            if (typeof value === 'string') {
                return value;
            }

            if (typeof value === 'number' || typeof value === 'boolean') {
                return String(value);
            }

            if (Array.isArray(value)) {
                return value.map(item => this.normalizeBindinfValue(item)).join(',');
            }

            if (typeof value === 'object') {
                if (value.text !== undefined) {
                    return String(value.text);
                }
                if (value.value !== undefined) {
                    return String(value.value);
                }
                return JSON.stringify(value);
            }

            return '';
        },
        // 获取文件解析内容
        async getfileCont(file) {
            const resFile = await getfilecontent({
                path: file
            })
            if (resFile.code === 0) {
                return resFile.data
            }
            else{
                this.$message.error(resFile.msg)
                return false
            }
        },
        // 获取文件类型
        getFileType(fileName) {
            const extension = fileName.split('.').pop().toUpperCase();
            return extension || 'Unknown';
        },
        // 格式化文件大小
        formatFileSize(contentLength) {
            // 假设每个字符占用 2 字节（UTF-16编码）
            const bytes = contentLength * 2;
            const units = ['B', 'KB', 'MB', 'GB'];
            let size = bytes;
            let unitIndex = 0;

            while (size >= 1024 && unitIndex < units.length - 1) {
                size /= 1024;
                unitIndex++;
            }

            return size > 0 ? `${Math.round(size)}${units[unitIndex]}` : '0B';
        },
        // 上传文件成功处理
        async handleAvatarSuccess(res, file) {
            const obj = {
                path: res
            }
            const resFile = await getfilecontent(obj)
            if (resFile.code === 0) {
                // 添加文件到fileList
                this.fileList.push({
                    name: file.name,
                    size: this.formatFileSize(resFile.data.length),
                    path: res,
                    data: resFile.data,
                    type: this.getFileType(file.name)
                });
            } else {
                this.$message.error(resFile.msg);
            }
        },
        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg'
            const isPNG = file.type === 'image/png'
            const isGIF = file.type === "image/gif";
            const isPDF = file.type === 'application/pdf'
            const isXLS = file.type === 'application/vnd.ms-excel'
            const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            const isTXT = file.type === 'text/plain'
            const isDOC = file.type === 'application/msword'
            const isDOCX = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'

            if (!isJPG && !isPNG && !isGIF && !isPDF && !isXLS && !isXLSX && !isTXT && !isDOC && !isDOCX) {
                this.$message.error('上传文件只能是图片、pdf、excel、 txt、doc 或 docx 格式!')
                return false
            }
            return true
        },
        async getKnowledge(val){
            let sendMessage = val
            let userMsg = localStorage.getItem("userMsg")
            let schoolId = null
            let konwledgeVal = ''
            if (userMsg) {
                schoolId = JSON.parse(userMsg).schoolMsg.schoolId
            }
            for (let i = 0; i < this.valueKnowledge.length; i++) {
                const query = {
                question: sendMessage,
                schoolId: schoolId,
                knowledgeBaseId: this.valueKnowledge[i],
                }
                console.log("query==",query);

                const { code, data } = await getquestionknowledge(query)
                if (code === 0 && data !== '') {
                konwledgeVal += `<div style='display: none;'> ${data}</div>`
                }
            }
            sendMessage += konwledgeVal
            const lastSession = this.sessions[this.sessions.length - 1];
            lastSession.content = sendMessage
            return lastSession
        },
        // 快速回答
        quickAnswer(item){
            this.queryMessage = item.describe
            this.communicate()
        },
        // 修改communicate方法
        async communicate() {
            // 判断是否有对话内容
            if (this.queryMessage === '' || this.queryMessage === '\n') {
                this.queryMessage = ''
                if (this.$refs.editor) {
                    this.$refs.editor.focus()
                }
                return
            }
            if (this.thinking) {
                this.$message.warning('正在努力分析中，请勿重复提交')
                return
            }
            const block = document.getElementById('chat-msg')
            this.sendMessage = this.queryMessage
            // 第一段对话加入预设参数
            if (this.sessions.length === 0 && Object.prototype.hasOwnProperty.call(this.param, 'bindinf') && this.param.bindinf && this.systemSwitch === 0) {
                const systemContent = await this.getSystemMessage();
                console.log("systemContent==",systemContent)
                this.sendMessage = "<div style='display: none;'>" + systemContent + "</div>" + this.queryMessage;
            }
            // 如果上传了文件，将文件内容添加到发送消息中
            if(this.fileList.length > 0){
                const fileCount = this.fileList.length;
                const fileContents = this.fileList.map((file, index) =>
                    `文档${index + 1}:${file.name}\n内容:${file.data}`
                ).join('\n');
                this.sendMessage = this.sendMessage + `<div style='display: none;'>\n\n以下是我上传的${fileCount}份文档：\n${fileContents}</div>`;
            }


            // 超过128KB则截取前128KB
            const MAX_LEN = 128 * 1024;
            if (typeof this.sendMessage === 'string' && this.sendMessage.length > MAX_LEN) {
                this.sendMessage = this.sendMessage.slice(0, MAX_LEN);
                this.$message.warning('内容过长，已截取前128KB');
            }
            if(this.sessions.length === 0 && this.systemSwitch === 1){
                const systemContent = await this.getSystemMessage();
                if (systemContent) {
                    this.sessions.push({
                        role: 'system',
                        content: systemContent
                    });
                }
            }
            // 用户询问
            this.sessions.push({
                role: 'user',
                content: this.sendMessage,
                id: Date.now(),
                edit: false
            })

            // 知识库使用前先调用这个接口将返回值拼接到问题后面
            if (this.isKnowledge && this.knowledgeInfo.id) {
                const query = {
                    question: this.sendMessage,
                    schoolId: this.knowledgeInfo.schoolId,
                    knowledgeBaseId: this.knowledgeInfo.id,
                }
                this.queryMessage = ''
                if (this.$refs.editor) {
                    this.$refs.editor.focus()
                }
                this.answerOver = false
                // 添加思考标签
                this.sessions.push({
                    role: 'assistant',
                    content: '',
                    id: Date.now(),
                    time: 0,
                    thinking: true
                });
                this.isKnowledgeStop = false
                const { code, data } = await getquestionknowledge(query)
                if (code === 0) {
                    if (this.sessions) {
                        const editIndex = this.sessions.length - 2
                        if (this.sessions[editIndex] && this.sessions[editIndex].content) {
                            this.sessions[editIndex].content = this.sendMessage += `<div style='display: none;'> ${data}</div>`
                        }
                    }
                }
            }

            this.$nextTick(function () {
                if (block.scrollHeight) block.scrollTop = block.scrollHeight
            })
            // 知识库暂停
            if(this.isKnowledge && this.knowledgeInfo.id && this.isKnowledgeStop) {
                this.knowledgeStop()
                return
            }
            // 调用机器人接口
            this.startAi()
        },
        async startAi() {
            this.searchApp()
            let msg = ''
            const block = document.getElementById('chat-msg')
            if (this.thinking) {
                this.$message.warning('正在努力分析中，请勿重复提交')
                return
            }
            this.think('thinking')
            this.answerOver = false
            let sessionsClone = cloneDeep(this.sessions)
            // 删除所有对象的 time 和 thinking 字段,避免重复提交的时候deepseek-r1:14b接口报错
            sessionsClone.forEach(item => {
                delete item.time;
                delete item.thinking;
            });
            // 知识库去掉最后一个节点
            if (this.isKnowledge && this.knowledgeInfo.id) {
                sessionsClone.splice(sessionsClone.length - 1, 1)
            }
            if (this.valueModel === 'yiyan') {
                this.answerType(sessionsClone).then(res => {
                    this.think('thinkout')
                    this.answerOver = true
                    msg = res.data.result
                    if (!this.startRobot) return;
                    // if (this.sessions.length === 1 && this.queryMessage) {
                    //     this.sessions[0].content = this.queryMessage
                    // }
                    if (this.isKnowledge && this.knowledgeInfo.id){
                        const editIndex = this.sessions.length - 1
                        if (this.sessions[editIndex] && this.sessions[editIndex].content) {
                            this.sessions[editIndex].content = msg
                        }
                    } else {
                        this.queryMessage = ''
                        if (this.$refs.editor) {
                            this.$refs.editor.focus()
                        }
                        this.sessions.push({
                            role: 'assistant',
                            content: msg,
                            id: Date.now(),
                            time: 0,
                            thinking: true
                        })
                    }
                })
            }
            else if (this.valueModel === 'doubao-video') {
                this.genDoubaoVideo(this.queryMessage, this.valueDoubaoVR, this.valueDoubaoVD)
            }
            else if (this.valueModel === 'doubao-image') {
                this.genDoubaoImage(this.queryMessage, this.valueDoubaoIS)
            }
            else {
                console.log("自训模型==", sessionsClone)
                // 创建新的 AbortController
                this.abortController = new AbortController();
                let obj = {
                    model: 'llamawxs',
                    messages: sessionsClone,
                    stream: false
                }
                // 如果配置了知识库
                if (this.valueKnowledge && this.valueKnowledge.length > 0) {
                    const sessionCont = this.sessions[this.sessions.length - 1];
                    console.log("sessionCont==", sessionCont.content);
                    const lastSession = await this.getKnowledge(this.filterHtmlTags(sessionCont.content));
                    console.log("lastSession==", lastSession);
                    // 超过128KB则截取前128KB
                    const MAX_LEN = 128 * 1024;
                    if (lastSession && typeof lastSession.content === 'string' && lastSession.content.length > MAX_LEN) {
                    lastSession.content = lastSession.content.slice(0, MAX_LEN);
                    }
                    this.sessions[this.sessions.length - 1] = lastSession
                    obj.messages = this.sessions;
                }
                const config = {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + "token",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(obj),
                    signal: this.abortController.signal // 添加 signal
                }
                let _url = 'https://wxs.topeti.com/api/chat'
                // 电信模型 
                if (this.valueModel === 'dx-deepseek671b') {
                    obj.model = '/data/nvme0/models/DeepSeek-R1-AWQ'
                    obj.stream = true
                    _url = 'https://eduxm.topeti.com/v1/chat/completions'
                }
                // 本地部署deeepseek
                else if (this.valueModel === 'deepseek' || this.valueModel === 'yiwen') {
                    obj.model = 'deepseek-r1:14b'
                    obj.stream = true
                }
                // 官方满血deepseek
                else if (this.valueModel === 'deepseek-reasoner' || this.valueModel === 'deepseek-chat') {
                  obj.model = this.valueModel
                  obj.stream = true
                  _url = 'https://user.topeti.com/deepseek/chat'
                  const user = window.localStorage.getItem('user')
                  let accesstoken = ''
                  if (user ) {
                    accesstoken = JSON.parse(user).accesstoken
                  }
                  config.headers.accesstoken = accesstoken
                  config.headers.originapi = this.$url
                  delete config.headers.Authorization
                } 
                config.body = JSON.stringify(obj)               
                fetch(_url, config)
                .then(response => {
                    // if (this.sessions.length === 1 && this.queryMessage) {
                    //     this.sessions[0].content = this.queryMessage
                    // }
                    if (this.isKnowledge && this.knowledgeInfo.id){
                        const editIndex = this.sessions.length - 1
                        if (this.sessions[editIndex] && this.sessions[editIndex].content) {
                            this.sessions[editIndex].content = msg
                        }
                    } else {
                        this.queryMessage = ''
                        if (this.$refs.editor) {
                            this.$refs.editor.focus()
                         }
                        // 添加思考标签
                        this.sessions.push({
                            role: 'assistant',
                            content: '',
                            id: Date.now(),
                            time: 0,
                            thinking: true
                        });
                    }
                    this.handleStreamResponse(response)
                })
                .catch(error => {
                    if (error.name === 'AbortError') {
                        console.log('请求被中止');
                    } else {
                        console.error('Fetch error:', error);
                    }
                    this.think('thinkout');
                    this.answerOver = true;
                });
            }
            this.$nextTick(function () {
                if (block && block.scrollHeight) block.scrollTop = block.scrollHeight
            })
        },
        async searchApp () {
            this.appCheckResult = []
            if (this.appCheckList.length > 0 && this.queryMessage) {
                const query = {
                    data: this.appCheckList,
                    content: this.queryMessage
                }
                const { code, data } = await getsampleword(query)
                if (code === 0) {
                    this.appCheckResult = data.map(item => { return this.getBtnInfo(item) })
                    this.addAppCheckResult()
                }
            }
        },
        addAppCheckResult () {
            if (this.appCheckResult.length > 0) {
                const lastSession = this.sessions[this.sessions.length - 1];
                if (lastSession.role === 'assistant') {
                    lastSession.appCheckResult = this.appCheckResult
                    this.appCheckResult = []
                }
            }
        },
        // 优化的流处理方法
        async handleStreamResponse(response) {
            const reader = response.body.getReader();
            const FORCE_ENABLE_FEATURE = true;
            let lastFinishReason = null;
            let streamDone = false; // 标记流数据是否读取完成
            this.showContinueBtn = false; // 是否显示继续生成按钮

            // 检查并显示“继续生成”按钮的函数
            const checkshowContinue = () => {
                if (!this.showContinueBtn && streamDone && lastFinishReason === 'length' && !this.isRendering && this.renderBuffer.length === 0) {
                    this.showContinueBtn = true;
                    console.log("this.sessions==",this.sessions);
                }
            };

            const processChunk = () => {
                if (this.renderBuffer.length === 0) {
                    this.isRendering = false;
                    // 更新HTML代码块状态（从loading变为completed）
                    if (streamDone) {
                        this.updateHtmlCodeBlocksStatus();
                    }
                    // 检查是否满足所有条件：流数据完成 + finish_reason === 'length' + 渲染完成
                    checkshowContinue();
                    return;
                }

                const chunk = this.renderBuffer.shift();
                if (!this.sessions.length || this.sessions[this.sessions.length - 1].role !== 'assistant') {
                    this.sessions.push({
                        role: 'assistant',
                        content: chunk,
                        id: Date.now(),
                        time: 0,
                        thinking: true
                    });
                } else {
                    const lastSession = this.sessions[this.sessions.length - 1];
                    lastSession.content += chunk;
                    nextTick(() => {
                        const wrap = document.querySelector('#chat-msg .el-scrollbar__wrap');
                        if (wrap) {
                        const threshold = 0;
                        // 只有用户没有主动滚动，或者本来就在底部，才自动滚动
                        if (!this.userHasScrolled || wrap.scrollTop + wrap.clientHeight >= wrap.scrollHeight - threshold) {
                            wrap.scrollTop = wrap.scrollHeight;
                        }
                        }
                    })
                }

                if (this.renderBuffer.length > 0) {
                    requestAnimationFrame(processChunk);
                } else {
                    this.isRendering = false;
                    // 更新HTML代码块状态（从loading变为completed）
                    if (streamDone) {
                        this.updateHtmlCodeBlocksStatus();
                    }
                    // 检查是否满足所有条件：流数据完成 + finish_reason === 'length' + 渲染完成
                    checkshowContinue();
                }
            }

            try {
                while (FORCE_ENABLE_FEATURE) {
                    const { done, value } = await reader.read();
                    this.addAppCheckResult()
                    if (done) {
                        streamDone = true; // 标记流数据读取完成
                        break;
                    }

                    // 检查是否被中止
                    if (this.abortController.signal.aborted) {
                        reader.cancel(); // 取消读取流
                        streamDone = true; // 标记流数据读取完成
                        break;
                    }

                    // 解码新的数据块
                    const chunk = new TextDecoder().decode(value);
                    const lines = chunk.split('\n');

                    for (const line of lines) {
                        if (!line.trim()) continue;
                        if (line === 'data: [DONE]') {
                            streamDone = true; // 标记流数据读取完成
                            continue;
                        }

                        try {
                            const cleanedLine = line.replace(/^data: /, '');
                            const parsedData = JSON.parse(cleanedLine);

                            // 安全地获取 reasoning_content
                            let reaContent = null;
                            if (this.valueModel === 'deepseek-reasoner' &&
                                parsedData &&
                                parsedData.choices &&
                                parsedData.choices[0] &&
                                parsedData.choices[0].delta) {
                                reaContent = parsedData.choices[0].delta.reasoning_content || null;
                            }

                            // 安全地获取 content
                            let content = null;
                            if (this.valueModel === 'dx-deepseek671b' ||
                                this.valueModel === 'deepseek-reasoner' ||
                                this.valueModel === 'deepseek-chat') {
                                // 优先从 delta.content 获取，如果没有则从 text 获取
                                if (parsedData && parsedData.choices && parsedData.choices[0]) {
                                    const choice = parsedData.choices[0];
                                    if (choice.delta && choice.delta.content !== undefined) {
                                        content = choice.delta.content;
                                    } else if (choice.text !== undefined) {
                                        content = choice.text;
                                    } else if (choice.delta && choice.delta.text !== undefined) {
                                        content = choice.delta.text;
                                    }
                                }
                            } else {
                                // 其他模型从 message.content 获取
                                if (parsedData && parsedData.message && parsedData.message.content !== undefined) {
                                    content = parsedData.message.content;
                                }
                            }

                            // 记录最后一次的 finish_reason（如果存在）
                            if (parsedData && parsedData.choices && parsedData.choices[0] && Object.prototype.hasOwnProperty.call(parsedData.choices[0], 'finish_reason')) {
                            const fr = parsedData.choices[0].finish_reason;
                            if (fr !== null && fr !== undefined) {
                                lastFinishReason = fr;
                            }
                            }

                            // 处理思考标签和计时
                            if (content === '<think>' || (this.valueModel === 'deepseek-reasoner' && reaContent !== null && content === null && this.timer === null)) {
                                content = '<div class="think">';
                                if(this.valueModel === 'deepseek-reasoner'){
                                content = '<div class="think">' + reaContent
                                }
                                // 开始计时
                                this.startTime = Date.now();
                                this.timer = setInterval(() => {
                                    if (this.sessions.length > 0) {
                                        const lastSession = this.sessions[this.sessions.length - 1];
                                        lastSession.time = Math.floor((Date.now() - this.startTime) / 1000);
                                    }
                                }, 1000);
                            } else if(this.valueModel === 'deepseek-reasoner' && reaContent !== null && content === null && this.timer){
                                content = reaContent
                            } else if (content === '</think>' || (this.valueModel === 'deepseek-reasoner' && reaContent === null && content !== null && this.timer)) {
                                if(this.valueModel === 'deepseek-reasoner'){
                                content = '</div>' + content
                                }
                                else{
                                content = '</div>';
                                }
                                // 停止计时并记录最终时间
                                if (this.timer) {
                                    clearInterval(this.timer);
                                    this.timer = null;
                                    if (this.sessions.length > 0) {
                                        const lastSession = this.sessions[this.sessions.length - 1];
                                        lastSession.time = Math.floor((Date.now() - this.startTime) / 1000);
                                        lastSession.thinking = false;
                                    }
                                }
                            }

                            if (content) {
                                this.toSaveText(content)
                                // 将内容分片添加到渲染缓冲区
                                this.renderBuffer.push(content);

                                if (!this.isRendering) {
                                    this.isRendering = true;
                                    requestAnimationFrame(processChunk);
                                }
                            }
                        } catch (e) {
                            console.error('Error parsing JSON:', e);
                        }
                    }
                }
            } catch (error) {
                if (error.name === 'AbortError') {
                    console.log('流读取被中止');
                } else {
                    console.error('Stream reading error:', error);
                }
            } finally {
                // 清理状态
                if (this.timer) {
                    clearInterval(this.timer);
                    this.timer = null;
                }
                this.addAppCheckResult()
                this.answerOver = true;
                this.think('thinkout');
                this.abortController = null;
                this.answerOver = true;
                // 渲染 Mermaid 图表
                this.renderMermaidCharts();
                // 更新HTML代码块状态（从loading变为completed）
                if (streamDone) {
                    this.updateHtmlCodeBlocksStatus();
                }
                // 如果流数据已完成且渲染缓冲区为空，检查是否需要显示“继续生成”按钮
                // 如果还有数据在渲染，会在 processChunk 中检查
                checkshowContinue();
            }
        },
        // 继续生成
        continueAnswer() {
            const block = document.getElementById('chat-msg')
            if (this.thinking) {
                this.$message.warning('正在努力分析中，请勿重复提交')
                return
            }
            if (!this.sessions || this.sessions.length === 0) {
                this.$message.warning('没有可继续生成的内容')
                return
            }

            this.think('thinking')
            this.answerOver = false
            this.showContinueBtn = false // 隐藏继续生成按钮

            // 获取现有的 sessions，并在最后一个元素上添加 prefix: true
            let sessionsClone = cloneDeep(this.sessions)
            const lastIndex = sessionsClone.length - 1
            if (lastIndex >= 0 && sessionsClone[lastIndex]) {
                sessionsClone[lastIndex].prefix = true
            }

            // 删除所有对象的 time 和 thinking 字段,避免重复提交的时候deepseek-r1:14b接口报错
            sessionsClone.forEach(item => {
                delete item.time;
                delete item.thinking;
            });

            // 知识库去掉最后一个节点
            if (this.isKnowledge && this.knowledgeInfo.id) {
                sessionsClone.splice(sessionsClone.length - 1, 1)
            }

            if (this.valueModel === 'yiyan') {
                this.answerType(sessionsClone).then(res => {
                    this.think('thinkout')
                    this.answerOver = true
                    const msg = res.data.result
                    if (!this.startRobot) return;

                    if (this.isKnowledge && this.knowledgeInfo.id){
                        const editIndex = this.sessions.length - 1
                        if (this.sessions[editIndex] && this.sessions[editIndex].content) {
                            this.sessions[editIndex].content += msg
                        }
                    } else {
                        // 继续在最后一个元素上追加内容
                        const lastSession = this.sessions[this.sessions.length - 1]
                        if (lastSession) {
                            lastSession.content += msg
                        }
                    }
                })
            }
            else {
                console.log("继续生成-自训模型==", sessionsClone)
                // 创建新的 AbortController
                this.abortController = new AbortController();
                let obj = {
                    model: 'llamawxs',
                    messages: sessionsClone,
                    stream: false
                }
                const config = {
                    method: "POST",
                    headers: {
                        Authorization: "Bearer " + "token",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(obj),
                    signal: this.abortController.signal // 添加 signal
                }
                let _url = 'https://wxs.topeti.com/api/chat'
                // 电信模型
                if (this.valueModel === 'dx-deepseek671b') {
                    obj.model = '/data/nvme0/models/DeepSeek-R1-AWQ'
                    obj.stream = true
                    _url = 'https://eduxm.topeti.com/v1/chat/completions'
                }
                // 本地部署deeepseek
                else if (this.valueModel === 'deepseek' || this.valueModel === 'yiwen') {
                    obj.model = 'deepseek-r1:14b'
                    obj.stream = true
                }
                // 官方满血deepseek
                else if (this.valueModel === 'deepseek-reasoner' || this.valueModel === 'deepseek-chat') {
                  obj.model = this.valueModel
                  obj.stream = true
                  // 获取最后的消息内容作为 prompt
                  const lastUserMessage = sessionsClone.filter(item => item.role === 'assistant').pop()
                  obj.prompt = lastUserMessage && lastUserMessage.content ? lastUserMessage.content : ''
                  _url = 'https://user.topeti.com/deepseek/beta'
                  const user = window.localStorage.getItem('user')
                  let accesstoken = ''
                  if (user ) {
                    accesstoken = JSON.parse(user).accesstoken
                  }
                  config.headers.accesstoken = accesstoken
                  config.headers.originapi = this.$url
                  delete config.headers.Authorization
                }
                config.body = JSON.stringify(obj)
                fetch(_url, config)
                .then(response => {
                    if (this.isKnowledge && this.knowledgeInfo.id){
                        const editIndex = this.sessions.length - 1
                        if (this.sessions[editIndex] && this.sessions[editIndex].content) {
                            // 继续生成时，内容会通过流处理追加
                        }
                    } else {
                        // 继续生成时，确保最后一个元素存在且是 assistant 角色
                        // 这样流处理会在最后一个元素上追加内容，而不是创建新元素
                        const lastSession = this.sessions[this.sessions.length - 1]
                        if (!lastSession || lastSession.role !== 'assistant') {
                            this.sessions.push({
                                role: 'assistant',
                                content: '',
                                id: Date.now(),
                                time: 0,
                                thinking: true
                            });
                        } else {
                            // 如果最后一个元素存在，确保它有 content 属性（即使是空字符串）
                            if (lastSession.content === undefined) {
                                lastSession.content = ''
                            }
                        }
                    }
                    this.handleStreamResponse(response)
                })
                .catch(error => {
                    if (error.name === 'AbortError') {
                        console.log('请求被中止');
                    } else {
                        console.error('Fetch error:', error);
                    }
                    this.think('thinkout');
                    this.answerOver = true;
                });
            }
            this.$nextTick(function () {
                if (block && block.scrollHeight) block.scrollTop = block.scrollHeight
            })
        },
        // 知识库暂停
        knowledgeStop () {
            this.isKnowledgeStop = false
            this.answerOver = true
            const editIndex = this.sessions.length - 1
            if (this.sessions[editIndex]) {
                this.sessions[editIndex].content = '<div class="think"></div>'
            }
        },
        // 思考方法
        think(type) {
            if (type === 'thinking') {
                this.thinking = true
                this.thinkContent = 'AI小易正在生成...'
            } else {
                this.thinking = false
            }
        },
        // 插入预设参数
        async getSystemMessage() {
            const _html = dealText({
            text: this.param.bindinf || '',
            commonData: this.$store.state.userData,
            customData: this.param.customData,
            functionParms: this.param.functionParms || []
            });

            // 过滤预设参数中的HTML标签
            const filteredBindinf = this.filterHtmlTags(_html);
            console.log("filteredBindinf==", filteredBindinf);

            // 替换 bindinf 中的占位符
            const replacedBindinf = await this.replaceBindinfPlaceholders(filteredBindinf);

            return replacedBindinf;
        },
        // 检查是否需要显示滚动按钮
        checkScrollButtons() {
            const wrap = document.querySelector('#chat-msg .el-scrollbar__wrap');
            if (wrap) {
                const scrollHeight = wrap.scrollHeight;
                const clientHeight = wrap.clientHeight;
                const scrollTop = wrap.scrollTop;
                // console.log("scrollHeight==", scrollHeight, clientHeight, scrollTop);
                // 判断是否需要显示滚动按钮
                this.showScrollButtons = scrollHeight > clientHeight;
                // console.log("this.showScrollButtons111==", this.showScrollButtons);
                if (this.showScrollButtons) {
                    // 更新上下按钮的显示状态
                    this.showUpButton = scrollTop > 10; // 添加一个小阈值，避免精度问题
                    this.showDownButton = scrollTop < (scrollHeight - clientHeight - 10); // 同上
                } else {
                    // 如果不需要滚动，隐藏所有按钮
                    this.showUpButton = false;
                    this.showDownButton = false;
                }
                // 判断用户是否主动滚动且未到最底部
                const threshold = 90;
                if (scrollTop + clientHeight < scrollHeight - threshold) {
                    this.userHasScrolled = true;
                } else {
                    this.userHasScrolled = false;
                }
            }
        },

        // 处理滚动事件
        handleScroll() {
            nextTick(() => {
                const wrap = document.querySelector('#chat-msg .el-scrollbar__wrap');
                if (wrap) {
                const scrollHeight = wrap.scrollHeight;
                const clientHeight = wrap.clientHeight;
                const scrollTop = wrap.scrollTop;
                // 实时更新按钮显示状态
                // console.log("this.showScrollButtons222==", wrap, this.showScrollButtons);
                if (scrollHeight > clientHeight) {
                    this.showScrollButtons = true;
                    this.showUpButton = scrollTop > 10;
                    this.showDownButton = scrollTop < (scrollHeight - clientHeight - 10);
                } else {
                    this.showScrollButtons = false;
                    this.showUpButton = false;
                    this.showDownButton = false;
                }
                }
            })
            },

        // 滚动到指定位置
        scrollToPosition(direction) {
            nextTick(() => {
                const wrap = document.querySelector('#chat-msg .el-scrollbar__wrap');
                if (wrap) {
                if (direction === 'up') {
                    // 滚动到最上方
                    wrap.scrollTop = 0;
                } else {
                    // 滚动到最下方
                    wrap.scrollTop = wrap.scrollHeight;
                }

                // 更新按钮显示状态
                this.handleScroll();
                }
            })
        },

        // 监听内容变化
        watchContentChanges() {
            const observer = new MutationObserver(() => {
                // 使用 requestAnimationFrame 来优化性能
                requestAnimationFrame(() => {
                    this.checkScrollButtons();
                });
            });

            const config = {
                childList: true,
                subtree: true,
                characterData: true, // 添加文本内容变化的监听
                attributes: true // 添加属性变化的监听
            };

            if (this.$refs.scrollArea && this.$refs.scrollArea.$el) {
                observer.observe(this.$refs.scrollArea.$el, config);
                this._observer = observer;
            }
        },

        // 在内容更新后重新检查按钮状态
        updateScrollButtons() {
            this.$nextTick(() => {
                this.checkScrollButtons();
            });
        },

        // 移除文件
        removeFile(index) {
            this.fileList.splice(index, 1);
        },
        // 保存会话历史记录
        saveSessionHistory() {
            // 优先使用 approvalId，其次使用 chatId
            const historyKey = this.approvalId || this.customDeskInfo.chatId;
            
            // 没有 key 或没有会话数据则不保存
            if (!historyKey || this.sessions.length === 0) return;
            if(!this.approvalId || this.sessions.length === 0) return;
            let historymsg = localStorage.getItem('historymsg');
            // 如果 historymsg 为空，初始化为空对象
            if (!historymsg) {
                historymsg = '{}';
            }
            try {
                let historyObj = JSON.parse(historymsg);
                historyObj[historyKey] = JSON.stringify(this.sessions);
                localStorage.setItem('historymsg', JSON.stringify(historyObj));
            } catch (error) {
                console.error('Error saving session history:', error);
                // 如果解析失败，重新初始化
                const newHistory = {
                [historyKey]: JSON.stringify(this.sessions)
                };
                localStorage.setItem('historymsg', JSON.stringify(newHistory));
            }
        },
        // 计算可显示的标签数量
        calculateVisibleTags() {
            console.log("this.$refs.featureTags==", this.$refs.featureTags, this.$refs.tagsList, this.tags);
            if (!this.$refs.featureTags || !this.$refs.tagsList || this.tags.length === 0){
                console.log("this.$refs.featureTags==", this.$refs.featureTags, this.$refs.tagsList, this.tags);
                return
            }

            const containerWidth = this.$refs.featureTags.clientWidth - 50; // 减去"更多"按钮的宽度
            console.log("containerWidth==", containerWidth);
            
            let totalWidth = 0;
            let visibleCount = 0;

            // 重置可见性以便正确计算
            this.visibleTagCount = this.tags.length;
            this.$nextTick(() => {
                const tagItems = this.$refs.tagItems;
                if (!tagItems) return;

                for (let i = 0; i < tagItems.length; i++) {
                    const tagWidth = tagItems[i].offsetWidth + 10; // 10px为间距
                    if (totalWidth + tagWidth <= containerWidth) {
                        totalWidth += tagWidth;
                        visibleCount++;
                    } else {
                        break;
                    }
                }
                this.visibleTagCount = visibleCount;
            });
        },
        // 关闭弹窗
        closePop(){
            this.$emit('close')
        },
    },
    mounted() {
        this.$nextTick(() => {
            this.checkScrollButtons();
            this.watchContentChanges();  
            this.calculateVisibleTags();
            setupMarkdownExtension();
            this.bindHtmlCodeButtons();        
            window.addEventListener('resize', this.calculateVisibleTags);
            this.isInquire()
        });
    },
    updated() {
        this.$nextTick(() => {
        this.bindHtmlCodeButtons();
        });
    },
    // 组件销毁时清理计时器和 AbortController
    beforeUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
        }
        if (this.abortController) {
            this.abortController.abort();
            this.abortController = null;
        }

        // 清理事件监听和观察器
        window.removeEventListener('resize', () => {
            requestAnimationFrame(() => {
                this.checkScrollButtons();
            });
        });
        if (this._observer) {
            this._observer.disconnect();
        }

        // 保存会话历史记录
        this.saveSessionHistory();
    },
}
</script>
<style scoped lang="scss">
.chat-wrap {
    height: 100%;
    padding-bottom: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    position: relative;
    background: #fff;
    .btn-close-pop,
    .ai-temp3 {
        display: none;
    }
}
.chat-newui {
    background: transparent;
    box-sizing: border-box;
    padding-bottom: 40px;
    .btn-close-pop {
        display: block;
        position: absolute;
        right: 30px;
        top: 30px;
        color: #0049FF;
        z-index: 12;
        cursor: pointer;
        .iconfont {
            font-size:20px;
        }
    }
    .ai-temp2 {
        position: relative;
        background: url('https://bigdata.topeti.com/PCRepository/mainPlatform/pop-chat.jpg') no-repeat 50% 100%;
        background-size: 100%;
        .girl {
            margin-left: 20px;
            width: 149px;
        }
        p {
            font-size: 20px;
            color: #6370FD;
            height: 30px;
            line-height: 30px;
            margin-top: 60px;
        }
    }
    .ai-temp3 {
        display: block;
        position: relative;
        z-index: 11;
        height: 83px;
        background: url('https://bigdata.topeti.com/PCRepository/mainPlatform/pop-chat.jpg') no-repeat 50% 100%;
        background-size: 100% 100%;
        border-top-left-radius: 14px;
        border-top-right-radius: 14px;
        img {
            display: block;
            width: 100%;
        }
        .girl {
            position: absolute;
            left: 20px;
            bottom: 0;
            width: 120px;
        }
        p {
            position: absolute;
            left: 140px;
            top: 50%;
            margin-top: -15px;
            font-size: 20px;
            color: #6370FD;
            height: 30px;
            line-height: 30px;
        }
    }
    .history-btn {
        background: #fff;
        z-index: 13;
        top: 25px;
        left: auto;
        right: 80px;
    }
    .chat-main {
        background: linear-gradient(180deg, rgba(249, 248, 254, 1) 0%, rgba(253, 252, 253, 1) 100%);
        border-bottom-left-radius: 14px;
        border-bottom-right-radius: 14px;
        max-height: calc(100% - 93px);
        overflow: hidden;
        .ctoArray-class {
            padding-top: 10px !important;
        }
        .robot-wrap {
            flex: 1;
            width: 100%;
            overflow-y: auto;
        }
    }
    .v-md-editor {
        background: transparent !important;
    }
}

.history-btn {
    position: absolute;
    top: 20px;
    left: 50%;
    z-index: 10;
    transform: translateX(-50%);
    width: 152px;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #808598;
    text-align: center;
    border-radius: 31px;
    border: 1px solid #E0E0E0;
    cursor: pointer;
}

.chat-main {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}

.ai-intro {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    height: 92px;
    margin-bottom: 20px;
    max-width: calc(100% - 40px);
    .title {
        position: relative;    
        display: flex;
        align-items: center;
        justify-content: center;
        max-width: calc(100%);
        margin-bottom: 8px;
        padding-left: 55px;
        box-sizing: border-box;
        img {
            position: absolute;
            left: 0;
            top: 0;
            width: 48px;
            height: 48px;
            border-radius: 50%;
            margin-right: 10px;
        }

        h5 {
            height: 48px;
            line-height: 48px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin: 0;
            font-size: 26px;
            font-weight: bold;
            color: #000;
        }
    }

    p {
        max-width: calc(100% - 40px);
        margin: 0;
        font-size: 14px;
        color: #000;
        height: 36px;
        line-height: 36px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
}

.ctoArray-class {
    width: 100%;
    height: calc(100% - 179px);
    padding-left: 12px;
    box-sizing: border-box;
    position: relative;

    .scroll-btn {
        div {
            position: absolute;
            right: 20px;
            z-index: 10;
            width: 32px;
            height: 32px;
            line-height: 35px;
            text-align: center;
            background-color: #FFFFFF;
            border: 2px solid #EDEDED;
            cursor: pointer;
            border-radius: 50%;
            transition: all 0.3s ease;

            i {
                font-size: 18px;
                color: #262626;
            }

            &:hover {
                border-color: #4E86FF;

                i {
                    color: #4E86FF;
                }
            }
        }

        .btn-up {
            top: 20px;
        }

        .btn-down {
            bottom: 20px;
        }
    }

    .app-check-list {
        display: flex;
        padding: 10px 20px;
        width: 100%;
        box-sizing: border-box;
        flex-wrap: wrap;
        .app-check-tips {
            font-size: 12px;
            color: #999;
            width: 100%;
            margin-bottom: 12px
        }
    }
    .app-check-list {
        display: flex;
        padding: 20px 0px;
        margin-bottom: 20px;
        border-bottom: 1px solid #E7EAF0;
        width: 100%;
        box-sizing: border-box;
        flex-wrap: wrap;
        .app-check-tips {
            font-size: 12px;
            color: #999;
            width: 100%;
            margin-bottom: 12px
        }
    }
    .ai-list {
        .ai-list-sys,
        .ai-list-user {
            width: 36px;
            height: 36px;

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }

        .ai-list-sys {
            margin-right: 8px;
        }

        .ai-list-user {
            margin-left: 8px;
        }

        .ai-list-center {
            .ai-think {
                margin-top: 5px;
                display: inline-block;
                font-size: 12px;
                color: #262626;
                padding: 10px;
                border-radius: 10px;
                background-color: #F5F5F5;
                cursor: pointer;

                i {
                    font-size: 12px;
                    color: #262626;
                    transition: transform 0.3s;
                }

                .WSicon-icon_interests {
                    margin-right: 5px;
                }

                .icon-xiala {
                    margin-left: 5px;
                    display: inline-block;
                    transform: rotate(180deg);
                }

                &:hover {
                    background: #eee;
                }
            }

            .hide {
                .icon-xiala {
                    transform: rotate(0);
                }
            }

            .ai-list-text {
                font-size: 12px;
                color: #333333;
                line-height: 18px;                
                .ai-loading {
                    margin: 10px 0;
                    width: 24px;
                    height: 24px;
                    border: 2px solid #E7EAF0;
                    border-top: 2px solid #4E86FF;
                    border-radius: 50%;
                    animation: ai-loading-spin 1s linear infinite;
                }

                @keyframes ai-loading-spin {
                    0% {
                        transform: rotate(0deg);
                    }

                    100% {
                        transform: rotate(360deg);
                    }
                }
            }

            .ai-list-text-edit {
                max-width: calc(100% - 48px);
                margin: 0 auto;
                textarea {
                    width: 100%;
                    height: 100px;
                    overflow: auto;
                    outline: none;
                    font-size: 14px;
                    color: #000;
                    background: transparent;
                    border-radius: 24px;
                    border: 1px solid #4476EB;
                    resize: none;
                    padding: 10px;
                    box-sizing: border-box;
                    &:empty:before {
                        content: attr(data-placeholder);
                        color: #999;
                    }

                    &:focus {
                        outline: none;
                    }
                }
                .operate-btn {
                    display: flex;
                    justify-content: flex-end;
                    margin-top: 12px;
                    span {
                        display: block;
                        width: 56px;
                        height: 34px;
                        line-height: 34px;
                        font-size: 14px;
                        text-align: center;
                        border-radius: 16px;
                        cursor: pointer;
                        margin-right: 12px;
                    }
                    .btn-cancel {
                        color: #000;
                        background-color: #EDEDED;
                    }
                    .btn-send {
                        color: #fff;
                        background-color: #4476EB;
                    }
                }
            }

            .ai-button {
                display: flex;
                align-items: center;
                justify-content: space-between;
                cursor: pointer;
                padding-bottom: 10px;
                .ai-button-left {
                    display: flex;
                    align-items: center;

                    i {
                        font-size: 20px;
                        color: #81839A;
                        margin-right: 16px;
                    }
                }

                .ai-button-right {
                    margin-left: auto;
                }
            }
        }
    }

    .ai-list:last-child {
        margin-bottom: 40px;
    }

    .ai-user {
        .ai-list-center {
            .ai-list-text-wrapper {
                display: flex;
                align-items: self-start;
                text-align: left;
                justify-content: right;
                padding: 0 12px;
                position: relative;
                .ai-list-text {
                    display: inline-block;
                    position: relative;
                    max-width: calc(100% - 70px);
                    padding: 10px;
                    background-color: #EFF6FF;
                    border-radius: 12px;
                    .ai-edit {
                        position: absolute;
                        left: -32px; // 调整左侧距离
                        top: 0; // 改为顶部对齐
                        display: flex;
                        flex-direction: row; // 改为横向排列
                        gap: 4px; // 调整按钮间距
                        opacity: 0;
                        visibility: hidden;
                        transition: all 0.3s ease;

                        i {
                            cursor: pointer;
                            font-size: 18px;
                            color: #81839A;
                            padding: 0 3px;
                            width: 20px; // 固定宽度
                            height: 38px; // 固定高度
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            &:hover {
                                color: #4E86FF;
                            }
                        }
                    }

                    &:hover {
                        .ai-edit {
                            opacity: 1;
                            visibility: visible;
                        }
                    }
                }
            }            
        }
    }

    :deep(.ai-assistant) {
        position: relative;
        padding: 0 12px 0 40px;

        .ai-list-sys {
            position: absolute;
            top: 4px;
            left: 0;
        }

        .ai-list-text {
            display: block;
        }

        .github-markdown-body {
            padding: 0;
            color: #06071F;

            // 添加 data-v-md-line 样式
            div[data-v-md-line] {
                padding: 8px 0;
                line-height: 1.6;

                // 如果是第一行，移除顶部padding
                &[data-v-md-line="1"] {
                    margin-top: 10px;
                    padding-top: 0;
                    color: #8B8B8B;
                    border-left: 2px solid #e5e5e5;
                    padding-left: 9px;
                }
            }
        }
    }
}

.chat-box {
    width: 100%;
    max-width: 840px;
    margin: 0 auto;
    padding: 20px 20px 0;
    box-sizing: border-box;

    .feature-tags {
        position: relative;
        display: flex;
        align-items: center;
        gap: 10px;
        width: 100%;

        .feature-tags-list {
            display: flex;
            flex-wrap: nowrap;
            gap: 10px;
            margin-bottom: 8px;
            overflow: hidden;
            flex: 1;

            li {
                cursor: pointer;
                display: inline-flex;
                align-items: center;
                height: 24px;
                padding: 0 10px;
                color: #181C18;
                font-size: 14px;
                white-space: nowrap;
                border-radius: 6px;
                background-color: #F3F4F6;

                i {
                    margin-right: 5px;
                }

                &:hover {
                    color: #4E86FF;
                }
            }
        }

        .el-dropdown {
            display: flex;
            align-items: center;
            margin-bottom: 8px;
            flex-shrink: 0;

            .el-dropdown-link {
                cursor: pointer;
                color: #181C18;
                font-size: 14px;
                white-space: nowrap;
                height: 24px;
                line-height: 24px;
                padding: 0 10px;

                &:hover {
                    color: #181C18;
                    opacity: 0.8;
                }
            }
        }
    }

    .input-area-wrap {
        border-radius: 24px;
        border: 1px solid #E5E8EE;
        .file-list {
            .tips {
                font-size: 12px;
                color: #525252;
                line-height: 16px;
                padding: 8px 0 0 16px;
            }
            .list {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
                max-height: 100px;
                overflow-y: auto;
                padding: 6px 16px 8px;
                .item {
                    position: relative;
                    display: flex;
                    align-items: center;
                    flex: 0 0 calc(33.33% - 7px);
                    min-width: 0;
                    border-radius: 12px;
                    background-color: #F3F4F6;
                    padding: 10px 5px;
                    box-sizing: border-box;
                    cursor: pointer;
                    &:hover {
                        box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.3);
                    }
                    .icon {
                        width: 20px;
                        margin: 0 10px;
                        flex-shrink: 0;
                        i {
                            font-size: 20px;
                            color: #F8CA27;
                        }
                    }
                    .file-info {
                        flex: 1;
                        min-width: 0;
                        p {
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            margin: 0;
                            font-size: 12px;
                            color: #bbb;
                            &:first-child {
                                margin-bottom: 2px;
                                font-size: 14px;
                                color: #000;
                            }
                        }
                    }
                    .btn-close {
                        display: none;
                        position: absolute;
                        right: -6px;
                        top: -6px;
                        width: 20px;
                        height: 20px;
                        line-height: 20px;
                        text-align: center;
                        border-radius: 50%;
                        background-color: #fff;
                        border: 1px solid #e0e0e0;
                        i {
                            font-size: 12px;
                            color: #868686;
                        }
                    }
                    &:hover {
                        .btn-close {
                            display: block;
                        }
                    }
                }
            }
        }

        .input-area {
            margin: -1px;
            border-radius: 24px;
            background-color: #F3F4F6;
            border: 1px solid #E7EAF0;
            padding: 12px;
            box-sizing: border-box;
            transition: all 0.3s;

            &.input-border {
                border-color: #4475EB;
                background-color: #fff;
            }

            textarea {
                width: 100%;
                height: 48px;
                overflow: auto;
                outline: none;
                font-family: 'Microsoft YaHei', 'SimSun', 'Arial', sans-serif;
                font-size: 14px;
                color: #000;
                background: transparent;
                border: none;

                &:empty:before {
                    content: attr(data-placeholder);
                    color: #999;
                }

                &:focus {
                    outline: none;
                }
            }

            .input-tools {
                margin-top: 10px;
                display: flex;
                gap: 15px;
                color: #666;
                font-size: 14px;
                justify-content: space-between;
                align-items: center;

                :deep(.el-select) {
                    width: 100px;
                    margin-right: 3px;
                }

                .tool-item {
                    display: inline-block;
                    cursor: pointer;
                    height: 26px;
                    line-height: 26px;
                    font-size: 14px;
                    color: #5D5D5D;
                    padding: 0 10px;
                    margin-right: 5px;
                    border-radius: 58px;
                    background-color: #fff;
                    border: 1px solid #E0E0E0;

                    &:hover {
                        color: #4E86FF;
                    }
                }

                .fr {
                    display: flex;
                    align-items: center;
                    flex-shrink: 0;

                    .btn-file,
                    .btn-submit {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        cursor: pointer;
                        width: 40px;
                        height: 40px;
                        margin-left: 5px;
                        border-radius: 50%;
                        flex-shrink: 0;

                        i {
                            font-size: 26px;
                        }

                        .WSicon-a-Rectangle346240893 {
                            font-size: 18px;
                        }
                    }

                    .btn-file {
                        i {
                            color: #4c4c4c;
                        }
                    }

                    .btn-submit {
                        background-color: #D6DEE8;
                        cursor: not-allowed;

                        i {
                            color: #fff;
                        }

                        &.btn-submit-high {
                            background-color: #4E86FF;
                            cursor: pointer;

                            &:hover {
                                background-color: #66b1ff;
                            }
                        }
                    }
                }
            }
        }
    }    
}
.quick-answer-list {
    width: 100%;
    max-width: 840px;
    margin: 0 auto;
    padding: 20px 20px 0;
    box-sizing: border-box;
    .inner {
        padding: 0 20px 30px;
        border-radius: 18px;
        background-color: #F8F7FF;
        border: 1px solid #F0F1FB;
        .title {
            height: 58px;
            line-height: 58px;
            font-size: 16px;
            color: #000;
            padding-left: 33px;
            background: url('https://bigdata.topeti.com/PCRepository/mainPlatform/icon-quick.png') no-repeat 0 50%;
            background-size: 26px;
            border-bottom: 1px solid #fff;
        }
        .cont {
            display: flex;
            flex-wrap: wrap;
            gap: 15px;
            padding-top: 15px;
            .quick-answer-item {
                width: calc((100% - 30px) / 3); /* (100% - 2个间隙) / 3 */
                height: 42px;
                background-color: #fff;
                border-radius: 9px;
                display: flex;
                align-items: center;
                padding: 0 12px;
                box-sizing: border-box;
                cursor: pointer;
                /* 图片样式 */
                img {
                    width: 24px;
                    height: 24px;
                    border-radius: 4px;
                    object-fit: cover;
                    margin-right: 8px;
                    flex-shrink: 0;
                }

                /* 文本样式 */
                .quick-answer-item-text {
                    flex: 1;
                    font-size: 16px;
                    color: #000;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    line-height: 1.2;
                }
            }
        }
    }
}

.history-switch {
    display: flex;
    align-items: center;
    justify-content: right;
    margin-top: 8px;
    gap: 6px;
    padding: 0 12px;
    i {
        cursor: pointer;
        font-size: 14px;
        color: #4E86FF;
        
        &.disabled {
            color: #C0C4CC;
            cursor: not-allowed;
        }
        
        &:hover:not(.disabled) {
            color: #66b1ff;
        }
    }
    
    span {
        font-size: 12px;
        color: #606266;
    }
}
</style>
<style lang="scss">
/* 将样式作用到 v-md-editor 的预览区域，避免 scoped 隔离 */
.v-md-editor .v-md-editor-preview .github-markdown-body {
    .html-code-block-wrapper {
    position: relative;
    margin: 16px 0;
    }

    .html-code-block-wrapper pre {
    position: relative;
    padding-top: 50px !important;
    margin: 0 !important;
    }

    .html-code-loading {
    position: relative;
    padding: 10px 20px;
    border-radius: 14px;
    text-align: center;
    background: #fff;
    border: 1px solid #ccc;
    margin: 16px 0;
    }

    .html-code-loading-content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    }

    .html-code-loading-text {
    color: #373C53;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 12px;
    }

    .html-code-loading-text img {
    width: 112px;
    height: auto;
    flex-shrink: 0;
    }

    .html-code-completed {
    position: relative;
    padding: 10px 20px;
    border-radius: 14px;
    text-align: center;
    background: #fff;
    border: 1px solid #ccc;
    margin: 16px 0;
    }

    .html-code-completed-content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .html-code-actions {
        padding-left: 20px;
    }
    }

    .html-code-completed-text {
    color: #373C53;
    font-size: 16px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    gap: 12px;
    }

    .html-code-completed-text img {
    width: 112px;
    height: auto;
    flex-shrink: 0;
    }

    .html-code-container {
    position: relative;
    margin: 16px 0;
    }

    .html-code-container .html-code-actions {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1;
    display: flex;
    gap: 6px;
    }

    .html-code-container pre {
    position: relative;
    padding-top: 50px !important;
    margin: 0 !important;
    }

    .html-code-toggle-icon {
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 18px;
    font-style: normal;
    color: #4E86FF;
    cursor: pointer;
    transition: all 0.2s;
    flex-shrink: 0;
    }

    .html-code-toggle-icon:hover {
    color: #66b1ff;
    }

    .html-code-actions {
    display: flex;
    gap: 6px;
    }

    .html-code-btn {
    width: 100px;
    height: 40px;
    padding: 0;
    background: #4e86ff;
    color: #fff;
    border: 1px solid #4e86ff;
    border-radius: 58px;
    cursor: pointer;
    font-size: 12px;
    font-style: normal;
    transition: all 0.2s;
    backdrop-filter: blur(4px);
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    i {
        font-style: normal !important;
    }
    }
    .html-btn-result {
    width: 72px;
    height: 28px;
    }

    .html-code-btn i {
    font-size: 14px;
    line-height: 1;
    }

    .html-code-btn:hover {
    opacity: 0.9;
    }

    /* Prism 高亮 IDE 风格 */
    pre code { background: transparent !important;}

    /* html/markup 统一配色 */
    pre code.language-html,
    pre code.language-markup,
    pre .token.tag { color: #e06c75 !important; }
    pre .token.attr-name { color: #d19a66 !important; }
    pre .token.attr-value,
    pre .token.string { color: #98c379 !important; }
    pre .token.comment { color: #5c6370 !important; font-style: italic; }
    pre .token.punctuation { color: #abb2bf !important; }
    pre .token.doctype { color: #c678dd !important; }
    pre .token.script { color: #e5c07b !important; }
}
.mermaid-wrapper {
  margin: 20px 0;
  position: relative;
}

.mermaid-container {
  background: #f6f8fa;
  border-radius: 6px;
  padding: 20px;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e1e4e8;
  overflow: auto;
}

.mermaid-loading {
  color: #586069;
  font-size: 14px;
}

.mermaid-error {
  color: #d73a49;
  padding: 20px;
  text-align: center;
  font-size: 14px;
}

/* 暗色主题适配 */
@media (prefers-color-scheme: dark) {
  .mermaid-container {
    background: #161b22;
    border-color: #30363d;
  }
  
  .mermaid-loading {
    color: #8b949e;
  }
}

/* 图片生成块样式 */
.img-block {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-bottom: 10px;
}
.img-wrap {
  position: relative;
  width: 480px;
  min-height: 200px;
  margin-top: 10px;
  overflow: hidden;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
}
.img-wrap img {
  width: 100%;
  display: block;
}
.img-loading-mask {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f0f2f5;
  border-radius: 8px;
}
.img-spinner {
  width: 36px;
  height: 36px;
  border: 3px solid #d0d7de;
  border-top-color: #409eff;
  border-radius: 50%;
  animation: img-spin 0.8s linear infinite;
}
@keyframes img-spin {
  to { transform: rotate(360deg); }
}
.img-actions {
  position: absolute;
  left: 50%;
  bottom: 10px;
  z-index: 3;
  width: 195px;
  height: 38px;
  line-height: 38px;
  margin-left: -98px;
  display: flex;
  gap: 10px;
  justify-content: center;
  color: #fff;
  border-radius: 10px;
  background-color: #B0B7BE;
}
.img-btn {
  display: inline-block;
  color: #fff;
  font-size: 14px;
  cursor: pointer;
}
</style>